
// Announcement bar continuous scrolling (USA only - free shipping message)
document.addEventListener('DOMContentLoaded', function() {
    var announcement_track = document.querySelector('.announcement-track');
    if (!announcement_track) return;

    // Hide announcement bar for non-USA users
    var currency_code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD';
    var country_code = window.Shopify && window.Shopify.country ? window.Shopify.country : 'US';
    if (currency_code !== 'USD' && country_code !== 'US') {
        var announcement_bar = announcement_track.closest('.announcement-bar');
        if (announcement_bar) announcement_bar.style.display = 'none';
        return;
    }

    var announcement_container = announcement_track.parentElement;
    var original_text = 'Free shipping on U.S. orders over $75';

    // Create one text item
    function create_text_element() {
        var text_element = document.createElement('p');
        text_element.className = 'announcement-text';
        text_element.textContent = original_text;
        return text_element;
    }

    // Restart CSS animation to avoid visual jump after rebuild
    function restart_animation() {
        announcement_track.classList.add('is-not-animated');
        void announcement_track.offsetWidth; // Force reflow
        announcement_track.classList.remove('is-not-animated');
    }

    // Build two identical sets and animate -50% for a seamless loop
    function build_ticker() {
        announcement_track.innerHTML = '';

        var base_set = document.createElement('div');
        base_set.className = 'announcement-set';
        announcement_track.appendChild(base_set);

        // Ensure at least 4 items and fill container width
        var max_iterations = 50; // Safety limit to prevent infinite loop
        var iteration_count = 0;
        var container_width = announcement_container.offsetWidth || 0;
        
        while ((base_set.children.length < 4 || base_set.scrollWidth < container_width) && iteration_count < max_iterations) {
            base_set.appendChild(create_text_element());
            iteration_count++;
            
            // Additional safety check: if container width is 0, break after minimum items
            if (container_width === 0 && base_set.children.length >= 4) {
                break;
            }
        }
        
        // Log warning if we hit the safety limit
        if (iteration_count >= max_iterations) {
            console.warn('Announcement bar reached maximum iteration limit to prevent infinite loop');
        }

        // Duplicate set for seamless loop
        var clone_set = base_set.cloneNode(true);
        announcement_track.appendChild(clone_set);

        restart_animation();
    }

    build_ticker();

    var rebuild_timeout;
    window.addEventListener('resize', function() {
        if (rebuild_timeout) clearTimeout(rebuild_timeout);
        rebuild_timeout = setTimeout(build_ticker, 200);
    });
});

// Sticky detection for navigation elements
document.addEventListener('DOMContentLoaded', function() {
    const mainNav = document.querySelector('.main-nav');
    const secondaryNav = document.querySelector('.secondary-nav');
    const productFilter = document.querySelector('.collection-filter-section');
    
    function manageShadows() {
        // Check if secondary nav is visible
        const isSecondaryNavVisible = secondaryNav && secondaryNav.offsetParent !== null;
        
        // Check if collection filter is visible
        const isCollectionFilterVisible = productFilter && productFilter.offsetParent !== null;
        
        // Priority 1: Collection filter shadow (overrides all others when visible)
        if (isCollectionFilterVisible) {
            productFilter.classList.add('is-sticky');
            // Remove shadows from navigation elements when filter has shadow
            if (mainNav) mainNav.classList.add('hide-shadow');
            if (secondaryNav) secondaryNav.classList.add('hide-shadow');
        } else {
            if (productFilter) productFilter.classList.remove('is-sticky');
            // Allow navigation shadows when filter doesn't have shadow
            if (mainNav) mainNav.classList.remove('hide-shadow');
            if (secondaryNav) secondaryNav.classList.remove('hide-shadow');
            
            // Priority 2: Navigation shadows (only when collection filter is not visible)
            if (isSecondaryNavVisible) {
                // Secondary nav is visible - keep secondary nav default shadow, hide main nav shadow
                if (mainNav) mainNav.classList.add('hide-shadow');
                if (secondaryNav) secondaryNav.classList.remove('hide-shadow');
            } else {
                // Secondary nav is not visible - keep main nav default shadow, hide secondary nav shadow
                if (mainNav) mainNav.classList.remove('hide-shadow');
                if (secondaryNav) secondaryNav.classList.add('hide-shadow');
            }
        }
    }
    
    manageShadows();
    
    // Listen for secondary nav visibility changes
    var secondaryNavObserver = null;
    if (secondaryNav) {
        secondaryNavObserver = new MutationObserver(manageShadows);
        secondaryNavObserver.observe(secondaryNav, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    
    // Listen for collection filter visibility changes
    var filterObserver = null;
    if (productFilter) {
        filterObserver = new MutationObserver(manageShadows);
        filterObserver.observe(productFilter, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    
    // Clean up observers when page unloads
    window.addEventListener('beforeunload', function() {
        if (secondaryNavObserver) {
            secondaryNavObserver.disconnect();
        }
        if (filterObserver) {
            filterObserver.disconnect();
        }
    });
});

// Helper function to scroll filter tabs to show search input
function scrollToSearchTab() {
    var filter_tabs = document.querySelector('.filter-tabs');
    if (!filter_tabs) return;
    
    // Check if scrolling is needed (content overflows)
    if (filter_tabs.scrollWidth <= filter_tabs.clientWidth) {
        // No scrolling needed - all content is visible
        return;
    }
    
    var search_tab = document.getElementById('search-tab-container');
    if (!search_tab) {
        // Fallback: scroll to the right to show the search input
        filter_tabs.scrollLeft = filter_tabs.scrollWidth - filter_tabs.clientWidth;
        return;
    }
    
    // Calculate the position to center the search tab
    var search_tab_rect = search_tab.getBoundingClientRect();
    var filter_tabs_rect = filter_tabs.getBoundingClientRect();
    var scroll_position = search_tab.offsetLeft - (filter_tabs_rect.width / 2) + (search_tab_rect.width / 2);
    
    // Ensure we don't scroll past the boundaries
    scroll_position = Math.max(0, Math.min(scroll_position, filter_tabs.scrollWidth - filter_tabs.clientWidth));
    
    // Only scroll if the search tab is not fully visible
    var is_fully_visible = search_tab_rect.left >= filter_tabs_rect.left && 
                          search_tab_rect.right <= filter_tabs_rect.right;
    
    if (!is_fully_visible) {
        // Smooth scroll to position
        filter_tabs.scrollTo({
            left: scroll_position,
            behavior: 'smooth'
        });
    }
}

// Handle search icon clicks
function handleSearchClick(event) {
    event.preventDefault();
    
    // Check if search tab container exists (indicates we're on a page with search functionality)
    var search_tab_container = document.getElementById('search-tab-container');
    var search_input = document.getElementById('product-search');
    
    if (search_tab_container && search_input) {
        // We're on a page with search functionality - close mobile menu first
        var navbar_collapse = document.getElementById('navbar-nav');
        var navbar_toggler = document.querySelector('.navbar-toggler');
        
        // Close mobile menu if it's open
        if (navbar_collapse && navbar_collapse.classList.contains('show')) {
            navbar_collapse.classList.remove('show');
            if (navbar_toggler) {
                navbar_toggler.setAttribute('aria-expanded', 'false');
                navbar_toggler.classList.add('collapsed');
            }
        }
        
        // Force expand search by adding active class and focusing input
        search_tab_container.classList.add('active');
        
        // Focus on search input
        setTimeout(function() {
            search_input.focus();
            // Force keyboard to show on mobile
            if (search_input.setSelectionRange) {
                search_input.setSelectionRange(0, 0);
            }
            
            // Scroll to search section smoothly
            var filter_section = document.querySelector('.collection-filter-section');
            if (filter_section) {
                filter_section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            
            // Scroll filter tabs to show search input
            scrollToSearchTab();
        }, 150);
    } else {
        // Redirect to collection page with search parameter
        window.location.href = '/collections/all-products?search=open';
    }
}

// Navigation dropdown hover (desktop only) - using event delegation
document.addEventListener('DOMContentLoaded', function() {
    var nav_dropdowns = document.querySelectorAll('.nav-dropdown[data-dropdown]');
    
    nav_dropdowns.forEach(function(nav_dropdown) {
        var dropdown_id = nav_dropdown.getAttribute('data-dropdown');
        var dropdown_menu = document.getElementById(dropdown_id);
        var dropdown_toggle = nav_dropdown.querySelector('.dropdown-toggle');
        
        if (!dropdown_menu || !dropdown_toggle) return;
        
        // Show dropdown on mouseenter
        nav_dropdown.addEventListener('mouseenter', function() {
            if (window.innerWidth <= 768) return;
            
            // Close all other dropdowns first
            document.querySelectorAll('.dropdown-menu').forEach(function(menu) {
                if (menu.id !== dropdown_id) menu.classList.remove('show');
            });
            document.querySelectorAll('.dropdown-toggle').forEach(function(toggle) {
                if (toggle !== dropdown_toggle) toggle.classList.remove('active');
            });
            
            // Show current dropdown
            dropdown_menu.classList.add('show');
            dropdown_toggle.classList.add('active');
        });
        
        // Hide dropdown on mouseleave
        nav_dropdown.addEventListener('mouseleave', function() {
            if (window.innerWidth <= 768) return;
            
            setTimeout(function() {
                if (!dropdown_menu.matches(':hover') && !dropdown_toggle.matches(':hover')) {
                    dropdown_menu.classList.remove('show');
                    dropdown_toggle.classList.remove('active');
                }
            }, 150);
        });
    });
});

// Mobile navbar toggler
document.addEventListener('DOMContentLoaded', function() {
    var navbarToggler = document.querySelector('.navbar-toggler');
    var navbarCollapse = document.querySelector('#navbar-nav');
    if (navbarToggler && navbarCollapse) {
        navbarToggler.addEventListener('click', function() {
            var isExpanded = navbarToggler.getAttribute('aria-expanded') === 'true';
            navbarToggler.setAttribute('aria-expanded', (!isExpanded).toString());
            navbarToggler.classList.toggle('collapsed');
            navbarCollapse.classList.toggle('show');
        });
    }
});

// Handle mobile dropdown toggle
function toggleMobileDropdown(event, dropdown_id) {
    event.preventDefault();
    event.stopPropagation();
    
    var dropdown_menu = document.getElementById(dropdown_id);
    var dropdown_toggle = event.currentTarget;
    
    if (!dropdown_menu || !dropdown_toggle) return;
    
    // Close all other mobile dropdowns first
    var all_mobile_dropdowns = document.querySelectorAll('.mobile-dropdown-menu');
    var all_mobile_toggles = document.querySelectorAll('.mobile-dropdown .dropdown-toggle');
    
    all_mobile_dropdowns.forEach(function(menu) {
        if (menu.id !== dropdown_id) {
            menu.classList.remove('show');
        }
    });
    
    all_mobile_toggles.forEach(function(toggle) {
        if (toggle !== dropdown_toggle) {
            toggle.classList.remove('active');
        }
    });
    
    // Toggle current mobile dropdown
    dropdown_menu.classList.toggle('show');
    dropdown_toggle.classList.toggle('active');
}

// Carousels
document.addEventListener('DOMContentLoaded', function() {
    // Generic carousel initialization helper
    function initializeCarousel(container, options) {
        var track = container.querySelector(options.trackSelector);
        var leftBtn = container.querySelector(options.leftBtnSelector);
        var rightBtn = container.querySelector(options.rightBtnSelector);
        var items = container.querySelectorAll(options.itemSelector);
        
        var itemWidth = options.itemWidth;
        var containerWidth = container.clientWidth;
        var visibleItems = Math.floor(containerWidth / itemWidth);
        var currentPosition = 0;
        var totalItemsWidth = items.length * itemWidth - (options.gap || 20);
        // Use more precise calculation for larger items (like research carousel)
        var maxPosition = options.useCeilCalculation ? 
            Math.max(0, Math.ceil((totalItemsWidth - containerWidth) / itemWidth)) : 
            Math.max(0, items.length - visibleItems);
        
        function updateLayout() {
            if (totalItemsWidth <= containerWidth) {
                track.style.justifyContent = 'center';
                track.style.transform = 'translateX(0)';
                if (leftBtn) leftBtn.style.display = 'none';
                if (rightBtn) rightBtn.style.display = 'none';
            } else {
                track.style.justifyContent = 'flex-start';
                // Update the carousel position to current position
                var translateX;
                if (currentPosition === maxPosition && items.length > visibleItems) {
                    var totalItemsWidthInner = items.length * itemWidth - (options.gap || 20);
                    translateX = -(totalItemsWidthInner - containerWidth);
                } else {
                    translateX = -(currentPosition * itemWidth);
                }
                track.style.transform = 'translateX(' + translateX + 'px)';
                updateArrows();
            }
        }
        
        function updateArrows() {
            if (totalItemsWidth <= containerWidth) return;
            if (leftBtn) { leftBtn.style.display = currentPosition > 0 ? '' : 'none'; }
            if (rightBtn) { rightBtn.style.display = currentPosition < maxPosition ? '' : 'none'; }
        }
        
        function moveCarousel(direction) {
            if (direction === 'left' && currentPosition > 0) {
                currentPosition--;
            } else if (direction === 'right' && currentPosition < maxPosition) {
                currentPosition++;
            }
            
            var translateX;
            if (currentPosition === maxPosition && items.length > visibleItems) {
                var totalItemsWidthInner = items.length * itemWidth - (options.gap || 20);
                translateX = -(totalItemsWidthInner - containerWidth);
            } else {
                translateX = -(currentPosition * itemWidth);
            }
            
            if (track) { track.style.transform = 'translateX(' + translateX + 'px)'; }
            updateArrows();
        }
        
        if (leftBtn) { leftBtn.addEventListener('click', function() { moveCarousel('left'); }); }
        if (rightBtn) { rightBtn.addEventListener('click', function() { moveCarousel('right'); }); }
        
        // Touch/swipe functionality for mobile
        var startX = 0;
        var startY = 0;
        var isDragging = false;
        var startPosition = 0;
        var startTime = 0;
        
        function handleTouchStart(e) {
            if (totalItemsWidth <= containerWidth) return; // Don't handle touch if carousel is not scrollable
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            startTime = Date.now();
            isDragging = true;
            startPosition = currentPosition;
            track.style.transition = 'none'; // Disable transition during drag
        }
        
        function handleTouchMove(e) {
            if (!isDragging || totalItemsWidth <= containerWidth) return;
            
            var currentX = e.touches[0].clientX;
            var currentY = e.touches[0].clientY;
            var diffX = startX - currentX;
            var diffY = startY - currentY;
            
            // Only handle horizontal swipes (ignore vertical scrolling)
            if (Math.abs(diffX) > Math.abs(diffY)) {
                e.preventDefault(); // Prevent vertical scroll
                
                // Calculate bounds for resistance
                var maxTranslate = 0;
                var minTranslate = -(totalItemsWidth - containerWidth);
                var currentTranslate = -(currentPosition * itemWidth);
                
                // Apply resistance that follows the swipe direction naturally
                var resistance = 0.3; // Reduced resistance for more natural feel
                var newTranslate = currentTranslate - (diffX * resistance);
                
                // Clamp the translation within bounds
                newTranslate = Math.max(minTranslate, Math.min(maxTranslate, newTranslate));
                
                track.style.transform = 'translateX(' + newTranslate + 'px)';
            }
        }
        
        function handleTouchEnd(e) {
            if (!isDragging || totalItemsWidth <= containerWidth) return;
            
            isDragging = false;
            track.style.transition = ''; // Re-enable transition
            
            var currentX = e.changedTouches[0].clientX;
            var diffX = startX - currentX;
            var threshold = 30; // Reduced threshold for more responsive swipes
            var duration = Date.now() - startTime;
            var velocity = duration > 0 ? Math.abs(diffX) / duration : 0; // More accurate velocity calculation
            
            // Determine if swipe is significant enough
            var isSignificantSwipe = Math.abs(diffX) > threshold || velocity > 0.5;
            
            if (isSignificantSwipe) {
                if (diffX > 0) {
                    // Swipe left - move right (next items)
                    moveCarousel('right');
                } else {
                    // Swipe right - move left (previous items)
                    moveCarousel('left');
                }
            } else {
                // Snap back to current position
                var translateX = -(currentPosition * itemWidth);
                track.style.transform = 'translateX(' + translateX + 'px)';
            }
        }
        
        // Add touch event listeners to the track
        if (track) {
            track.addEventListener('touchstart', handleTouchStart, { passive: false });
            track.addEventListener('touchmove', handleTouchMove, { passive: false });
            track.addEventListener('touchend', handleTouchEnd, { passive: false });
        }
        
        updateLayout();
        
        window.addEventListener('resize', function() {
            containerWidth = container.clientWidth;
            visibleItems = Math.floor(containerWidth / itemWidth);
            totalItemsWidth = items.length * itemWidth - (options.gap || 20);
            maxPosition = options.useCeilCalculation ? 
                Math.max(0, Math.ceil((totalItemsWidth - containerWidth) / itemWidth)) : 
                Math.max(0, items.length - visibleItems);
            
            // Don't reset currentPosition on resize - preserve user's current position
            // Only reset if the new maxPosition is smaller and currentPosition exceeds it
            if (currentPosition > maxPosition) {
                currentPosition = maxPosition;
            }
            
            updateLayout();
        });
    }
    // Initialize carousel for each collection-carousel-container
    document.querySelectorAll('.collection-carousel-container').forEach(function(container) {
        initializeCarousel(container, {
            trackSelector: '.collection-carousel-track',
            leftBtnSelector: '.nav-left',
            rightBtnSelector: '.nav-right',
            itemSelector: '.collection-carousel-item',
            itemWidth: 300,
            gap: 20
        });
    });
    
    // Initialize carousel for each product-carousel-container
    document.querySelectorAll('.product-carousel-container').forEach(function(container) {
        initializeCarousel(container, {
            trackSelector: '.product-carousel-track',
            leftBtnSelector: '.nav-left',
            rightBtnSelector: '.nav-right',
            itemSelector: '.product-carousel-item',
            itemWidth: 320,
            gap: 20
        });
    });

    // Initialize carousel for each testimonial-carousel-container
    document.querySelectorAll('.testimonial-carousel-container').forEach(function(container) {
        initializeCarousel(container, {
            trackSelector: '.testimonial-carousel-track',
            leftBtnSelector: '.nav-left',
            rightBtnSelector: '.nav-right',
            itemSelector: '.testimonial-carousel-item',
            itemWidth: 300,
            gap: 20
        });
    });

    // Initialize process journey carousel
    document.querySelectorAll('.process-journey-carousel-container').forEach(function(container) {
        initializeCarousel(container, {
            trackSelector: '.process-journey-carousel-track',
            leftBtnSelector: '.process-journey-nav-left',
            rightBtnSelector: '.process-journey-nav-right',
            itemSelector: '.process-journey-carousel-item',
            itemWidth: 350,
            gap: 30,
            useCeilCalculation: true
        });
    });

    // Initialize research carousel
    document.querySelectorAll('.research-carousel-container').forEach(function(container) {
        initializeCarousel(container, {
            trackSelector: '.research-carousel-track',
            leftBtnSelector: '.research-nav-left',
            rightBtnSelector: '.research-nav-right',
            itemSelector: '.research-carousel-item',
            itemWidth: 380,
            gap: 30,
            useCeilCalculation: true
        });
    });

    // Initialize usage carousel
    document.querySelectorAll('.usage-carousel-container').forEach(function(container) {
        initializeCarousel(container, {
            trackSelector: '.usage-carousel-track',
            leftBtnSelector: '.usage-nav-left',
            rightBtnSelector: '.usage-nav-right',
            itemSelector: '.usage-carousel-item',
            itemWidth: 310,
            gap: 30,
            useCeilCalculation: true
        });
    });

    // Initialize article product carousel
    document.querySelectorAll('.article-product-carousel-container').forEach(function(container) {
        initializeCarousel(container, {
            trackSelector: '.article-product-carousel-track',
            leftBtnSelector: '.nav-left',
            rightBtnSelector: '.nav-right',
            itemSelector: '.article-product-carousel-item',
            itemWidth: 224,
            gap: 24
        });
    });
});

// Collection page
document.addEventListener('DOMContentLoaded', function() {
    function ab_get_nav_total_height() {
        const main_nav = document.querySelector('.main-nav');
        const secondary_nav = document.querySelector('.secondary-nav');
        const mobile_secondary_nav = document.querySelector('.mobile-secondary-nav');
        const is_visible = (el) => el && window.getComputedStyle(el).display !== 'none' && el.offsetParent !== null;
        const main_h = is_visible(main_nav) ? main_nav.offsetHeight : 0;
        const secondary_h = is_visible(secondary_nav) ? secondary_nav.offsetHeight : 0;
        const mobile_secondary_h = is_visible(mobile_secondary_nav) ? mobile_secondary_nav.offsetHeight : 0;
        return main_h + (mobile_secondary_h || secondary_h);
    }

    function ab_compute_filter_scroll_target() {
        const filter_section = document.querySelector('.collection-filter-section');
        if (!filter_section) { return 0; }
        const banner_content = document.querySelector('.feature-banner-content');
        const nav_total_height = ab_get_nav_total_height();
        const extra_offset = 8;
        const fine_tune = 10;
        if (banner_content) {
            const banner_rect = banner_content.getBoundingClientRect();
            const current_y = window.pageYOffset || document.documentElement.scrollTop || 0;
            const banner_bottom = current_y + banner_rect.bottom;
            return Math.max(banner_bottom - nav_total_height - extra_offset + fine_tune, 0);
        }
        let page_offset_top = 0;
        let el = filter_section;
        while (el) {
            page_offset_top += el.offsetTop || 0;
            el = el.offsetParent;
        }
        const base = Math.max(page_offset_top - nav_total_height - 16 + fine_tune, 0);
        const current_y = window.pageYOffset || document.documentElement.scrollTop || 0;
        return Math.abs(current_y - base) < 20 ? Math.max(base - 120, 0) : base;
    }

    function ab_scroll_to_target(target_y) {
        return new Promise(function(resolve) {
            const start_time = Date.now();
            const max_duration_ms = 1500;
            const threshold_px = 3;
            let last_y = window.pageYOffset || document.documentElement.scrollTop || 0;
            let stable_ticks = 0;
            function tick() {
                const current_y = window.pageYOffset || document.documentElement.scrollTop || 0;
                const at_target = Math.abs(current_y - target_y) <= threshold_px;
                if (at_target) { return resolve(); }
                if (Date.now() - start_time > max_duration_ms) { return resolve(); }
                if (Math.abs(current_y - last_y) <= 0.5) {
                    stable_ticks++;
                    if (stable_ticks >= 6) { return resolve(); }
                } else {
                    stable_ticks = 0;
                }
                last_y = current_y;
                requestAnimationFrame(tick);
            }
            window.scrollTo({ top: target_y, behavior: 'smooth' });
            requestAnimationFrame(tick);
        });
    }

    function ab_scroll_to_filter() {
        const target_y = ab_compute_filter_scroll_target();
        return ab_scroll_to_target(target_y);
    }

    // Handle unified collection filtering (new approach)
    function handle_unified_collection_filtering() {
        var products_section = document.querySelector('.products-section');
        if (!products_section) return;
        
        var current_filter = products_section.getAttribute('data-current-filter') || 'best-sellers';
        
        // Function to filter products using data-category attributes
        function filter_products_by_category(filter) {
            var items = document.querySelectorAll('.filter-item');
            
            items.forEach(function(item) {
                var categories = item.getAttribute('data-category');
                if (!categories) return;
                
                var category_list = categories.split(' ');
                
                if (category_list.includes(filter)) {
                    item.style.setProperty('display', 'block', 'important');
                } else {
                    item.style.setProperty('display', 'none', 'important');
                }
            });
        }
        
        // Initial filter is now applied server-side in Liquid template
        // No need to apply filter on page load
        
        // Add click handlers to filter tabs for unified filtering
        document.querySelectorAll('.filter-tab:not(.search-tab-container)').forEach(function(tab) {
            tab.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Update active state
                document.querySelectorAll('.filter-tab:not(.search-tab-container)').forEach(function(t) { 
                    t.classList.remove('active'); 
                });
                this.classList.add('active');
                
                var filter = this.getAttribute('data-filter');
                
                // Clear search if active
                var search_input = document.getElementById('product-search');
                var search_tab_container = document.getElementById('search-tab-container');
                if (search_input && (search_input.value.trim() !== '' || search_tab_container.classList.contains('active'))) {
                    search_input.value = '';
                    if (search_tab_container) {
                        search_tab_container.classList.remove('active');
                    }
                    // Reset search expanded state
                    is_search_expanded = false;
                    // Reset all filter items and product containers visibility after clearing search
                    document.querySelectorAll('.filter-item').forEach(function(item) {
                        item.style.setProperty('display', 'block', 'important');
                    });
                    document.querySelectorAll('.filter-item .col-xl-3, .filter-item .col-lg-4, .filter-item .col-md-6, .filter-item .col-sm-6').forEach(function(container) {
                        container.style.setProperty('display', 'block', 'important');
                    });
                }
                
                // Hide no results section
                var no_results_section = document.getElementById('no-results-section');
                if (no_results_section) { 
                    no_results_section.style.setProperty('display', 'none', 'important'); 
                }
                
                // Apply filter
                filter_products_by_category(filter);
                
                // Scroll to filter section
                ab_scroll_to_filter();
            });
        });
    }

    // Only bind if collection filter exists on the page
    if (document.querySelector('.collection-filter-section')) {
        handle_unified_collection_filtering();

        const search_tab_container = document.getElementById('search-tab-container');
        const search_input = document.getElementById('product-search');
        const search_close = document.getElementById('search-close');
        const no_results_section = document.getElementById('no-results-section');
        const no_results_reset = document.getElementById('no-results-reset');
        let search_timeout;
        let is_search_expanded = false;

        if (no_results_section) { no_results_section.style.setProperty('display', 'none', 'important'); }

        function activate_bestseller_tab() {
            const bestseller_tab = document.querySelector('.filter-tab[data-filter="best-sellers"]');
            if (!bestseller_tab) { return; }
            document.querySelectorAll('.filter-tab:not(.search-tab-container)').forEach(function(t) { t.classList.remove('active'); });
            bestseller_tab.classList.add('active');
        }

        function expand_search() {
            is_search_expanded = true;
            search_tab_container.classList.add('active');
            setTimeout(function() { 
                search_input.focus();
                // Force keyboard to show on mobile
                if (search_input.setSelectionRange) {
                    search_input.setSelectionRange(0, 0);
                }
            }, 150);
        }

        function collapse_search() {
            const had_search_content = search_input.value.trim() !== '';
            is_search_expanded = false;
            search_tab_container.classList.remove('active');
            if (search_timeout) { clearTimeout(search_timeout); }
            
            // Hide search feedback
            const search_feedback = document.getElementById('search-feedback');
            const search_loading = document.getElementById('search-loading');
            const search_results_count = document.getElementById('search-results-count');
            if (search_feedback) search_feedback.style.display = 'none';
            if (search_loading) search_loading.style.display = 'none';
            if (search_results_count) search_results_count.style.display = 'none';
            
            if (had_search_content) {
                search_input.value = '';
                if (no_results_section) { no_results_section.style.setProperty('display', 'none', 'important'); }
                
                // Reset all category sections and product containers visibility before applying Best Sellers
                document.querySelectorAll('.filter-item').forEach(function(section) {
                    section.style.setProperty('display', 'block', 'important');
                });
                document.querySelectorAll('.filter-item .col-xl-3, .filter-item .col-lg-4, .filter-item .col-md-6, .filter-item .col-sm-6').forEach(function(container) {
                    container.style.setProperty('display', 'block', 'important');
                });
                
                // Restore Best Sellers by triggering the tab click (same behavior as user click)
                const bestseller_tab = document.querySelector('.filter-tab[data-filter="best-sellers"]');
                if (bestseller_tab) {
                    bestseller_tab.click();
                } else {
                    // Fallback: show best-sellers via filter function
                    if (typeof filter_products_by_category === 'function') {
                        filter_products_by_category('best-sellers');
                    }
                    ab_scroll_to_filter();
                }
            } else {
                if (no_results_section) { no_results_section.style.setProperty('display', 'none', 'important'); }
            }
        }

        // Function to hide all products during search
        function hide_all_products() {
            const filter_items = document.querySelectorAll('.filter-item');
            filter_items.forEach(function(category_section) {
                // Hide the entire category section
                category_section.style.setProperty('display', 'none', 'important');
            });
        }

        // Direct matching function for precise search (no fuzzy matching)
        function directMatch(text, searchTerm) {
            // Direct substring match (highest priority)
            if (text.includes(searchTerm)) {
                return true;
            }
            
            // If search term is too short, only do direct matching
            if (searchTerm.length < 2) {
                return false;
            }
            
            // Word boundary matching - search term must match at word boundaries
            const words = text.split(/\s+/);
            for (let word of words) {
                // Exact word match (highest priority)
                if (word.toLowerCase() === searchTerm.toLowerCase()) {
                    return true;
                }
                
                // Word starts with search term (good match)
                if (word.toLowerCase().startsWith(searchTerm.toLowerCase())) {
                    return true;
                }
                
                // Search term is at least 4 characters and word contains it as substring
                if (searchTerm.length >= 4 && word.toLowerCase().includes(searchTerm.toLowerCase())) {
                    return true;
                }
            }
            
            return false;
        }

        function perform_search() {
            const search_term = search_input.value.toLowerCase().trim();
            
            // Require minimum 2 characters for search
            if (search_term.length >= 2) {
                search_tab_container.classList.add('active');
                // Activate best-sellers tab (default filter)
                const bestseller_tab = document.querySelector('.filter-tab[data-filter="best-sellers"]');
                if (bestseller_tab) {
                    document.querySelectorAll('.filter-tab:not(.search-tab-container)').forEach(function(t) { t.classList.remove('active'); });
                    bestseller_tab.classList.add('active');
                }
            } else if (!is_search_expanded) {
                search_tab_container.classList.remove('active');
            }

            // When input is cleared, restore Best Sellers via tab click and stop
            if (search_term === '') {
                const bestseller_tab = document.querySelector('.filter-tab[data-filter="best-sellers"]');
                if (bestseller_tab) {
                    bestseller_tab.click();
                } else {
                    if (typeof filter_products_by_category === 'function') {
                        filter_products_by_category('best-sellers');
                    }
                    if (no_results_section) { no_results_section.style.setProperty('display', 'none', 'important'); }
                }
                return;
            }
            
            // Use unified search approach with .filter-item elements
            const filter_items = document.querySelectorAll('.filter-item');
            let visible_count = 0;
            
            // New approach: Search within each category section
            filter_items.forEach(function(category_section) {
                // Find all product cards within this category
                const product_cards = category_section.querySelectorAll('.product-card');
                const carousel_card_element = category_section.querySelector('.carousel-card');
                const carousel_card_container = carousel_card_element ? carousel_card_element.closest('.col-xl-3, .col-lg-4, .col-md-6, .col-sm-6') : null;
                let category_has_matches = false;
                
                // Process each product card in this category
                product_cards.forEach(function(product_card) {
                    const product_container = product_card.closest('.col-xl-3, .col-lg-4, .col-md-6, .col-sm-6');
                    const title = product_card.querySelector('.product-title');
                    const description = product_card.querySelector('.product-description');
                    
                    if (title && description && product_container) {
                        const title_text = title.textContent.toLowerCase();
                        const desc_text = description.textContent.toLowerCase();
                        
                        let matches = false;
                        if (search_term === '') {
                            // Empty search - show all products
                            matches = true;
                        } else {
                            // Non-empty search - use direct matching for precise search
                            matches = directMatch(title_text, search_term) || directMatch(desc_text, search_term);
                        }
                        
                        if (matches) {
                            // Show individual product container
                            product_container.style.setProperty('display', 'block', 'important');
                            category_has_matches = true;
                            visible_count++;
                        } else {
                            // Hide individual product container
                            product_container.style.setProperty('display', 'none', 'important');
                        }
                    }
                });
                
                // Handle category section and carousel card visibility
                if (search_term === '') {
                    // Empty search - show everything
                    category_section.style.setProperty('display', 'block', 'important');
                    if (carousel_card_container) {
                        carousel_card_container.style.setProperty('display', 'block', 'important');
                    }
                } else {
                    // Active search
                    if (category_has_matches) {
                        // Category has matching products - show category and keep carousel card visible
                        category_section.style.setProperty('display', 'block', 'important');
                        if (carousel_card_container) {
                            carousel_card_container.style.setProperty('display', 'block', 'important');
                        }
                    } else {
                        // Category has no matching products - hide entire category
                        category_section.style.setProperty('display', 'none', 'important');
                    }
                }
            });
            
            // Show/hide no results section
            if (search_term !== '' && visible_count === 0) {
                no_results_section.style.setProperty('display', 'block', 'important');
            } else {
                no_results_section.style.setProperty('display', 'none', 'important');
            }
            
            // Hide search feedback when results are loaded
            const search_feedback = document.getElementById('search-feedback');
            const search_loading = document.getElementById('search-loading');
            const search_results_count = document.getElementById('search-results-count');
            
            if (search_loading) search_loading.style.display = 'none';
            
            if (search_term !== '') {
                // Hide search feedback completely when results are loaded
                if (search_feedback) search_feedback.style.display = 'none';
                
                // Scroll to filter section to show results properly
                ab_scroll_to_filter();
            } else {
                if (search_feedback) search_feedback.style.display = 'none';
                if (search_results_count) search_results_count.style.display = 'none';
            }
        }

        search_tab_container.addEventListener('click', function(e) {
            e.preventDefault();
            if (!is_search_expanded && !search_input.contains(e.target) && !search_close.contains(e.target)) { 
                expand_search(); 
                
                // Scroll to filter section (same as other filter tabs)
                ab_scroll_to_filter();
                
                // Scroll filter tabs to show search input
                scrollToSearchTab();
            }
        });
        search_input.addEventListener('focus', function() {
            // Scroll to filter section (same as other filter tabs)
            ab_scroll_to_filter();
        });
        
        search_input.addEventListener('input', function() {
            clearTimeout(search_timeout);
            
            const search_term = search_input.value.trim();
            const search_feedback = document.getElementById('search-feedback');
            const search_loading = document.getElementById('search-loading');
            const search_results_count = document.getElementById('search-results-count');
            
            if (search_term.length === 0) {
                // Empty search - hide feedback and show all products
                if (search_feedback) search_feedback.style.display = 'none';
                perform_search(); // This will show all products
                return;
            }
            
            if (search_term.length === 1) {
                // Too short - show message
                if (search_feedback) search_feedback.style.display = 'flex';
                if (search_loading) search_loading.style.display = 'none';
                if (search_results_count) {
                    search_results_count.style.display = 'flex';
                    search_results_count.textContent = 'Please enter at least 2 characters to search';
                }
                hide_all_products();
                return;
            }
            
            // Valid search term - show loading spinner
            if (search_feedback) search_feedback.style.display = 'flex';
            if (search_loading) search_loading.style.display = 'flex';
            if (search_results_count) search_results_count.style.display = 'none';
            
            // Hide all products immediately when user starts typing
            hide_all_products();
            
            // Add realistic delay for better UX
            search_timeout = setTimeout(perform_search, 800);
        });
        search_close.addEventListener('click', function(e) { e.preventDefault(); collapse_search(); });
        document.addEventListener('click', function(e) {
            if (is_search_expanded && !search_tab_container.contains(e.target)) {
                if (search_input.value.trim() === '') { collapse_search(); }
            }
        });
        document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && is_search_expanded) { collapse_search(); } });
        no_results_reset && no_results_reset.addEventListener('click', function(e) {
            e.preventDefault();
            collapse_search();
            const bestseller_tab = document.querySelector('.filter-tab[data-filter="best-sellers"]');
            if (bestseller_tab) { bestseller_tab.click(); }
        });
    }
});

// Product page
document.addEventListener('DOMContentLoaded', function() {
    
    // Product variants selection
    function bindVariantSelectors(rootSelector) {
        var root = document.querySelector(rootSelector);
        if (!root) { return; }
        root.querySelectorAll('.variant-selector').forEach(function(sel) {
            sel.addEventListener('click', function() {
                // Remove selected class from all selectors
                root.querySelectorAll('.variant-selector').forEach(function(s) { s.classList.remove('selected'); });
                // Add selected class to clicked selector
                sel.classList.add('selected');
                
                // Get the selected product and variant data
                var selected_product_id = sel.getAttribute('data-product');
                var selected_variant_id = sel.getAttribute('data-variant');
                
                if (selected_product_id && selected_variant_id) {
                    // Update form inputs
                    var form = document.querySelector('form[data-productid]');
                    var variant_input = document.getElementById('variant-id');
                    var add_to_cart_btn = document.querySelector('.add-to-cart-btn');
                    
                    if (form) {
                        form.setAttribute('data-productid', selected_product_id);
                    }
                    
                    if (variant_input) {
                        variant_input.value = selected_variant_id;
                    }
                    
                    if (add_to_cart_btn) {
                        add_to_cart_btn.setAttribute('data-variant-id', selected_variant_id);
                        
                        // Get pricing from selected variant selector
                        var price_compare_element = sel.querySelector('.price-compare');
                        var price_now_element = sel.querySelector('.price-now');
                        
                        if (price_compare_element && price_now_element) {
                            // Has compare price - calculate savings
                            var compare_price = price_compare_element.textContent.trim();
                            var current_price = price_now_element.textContent.trim();
                            
                            var compare_value = parseFloat(compare_price.replace(/[^0-9.]/g, ''));
                            var current_value = parseFloat(current_price.replace(/[^0-9.]/g, ''));
                            var savings = compare_value - current_value;
                            
                            // Only show save bubble if savings are valid and positive
                            if (!isNaN(savings) && savings > 0) {
                                // Check if free shipping applies (USA users, over $75)
                                var currency_code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'USD';
                                var country_code = (window.Shopify && window.Shopify.country) ? window.Shopify.country : 'US';
                                var is_usa_user = (currency_code === 'USD' || country_code === 'US');
                                var free_shipping_threshold_cents = 7500; // $75
                                var will_qualify_for_free_shipping = is_usa_user && (current_value * 100) >= free_shipping_threshold_cents;
                                
                                var currency_symbol = compare_price.replace(/[0-9.,\s]/g, '').trim() || '$';
                                var save_bubble_text = 'SAVE ' + currency_symbol + Math.round(savings);
                                if (will_qualify_for_free_shipping) {
                                    save_bubble_text += ' + FREE SHIPPING';
                                }
                                
                                add_to_cart_btn.className = 'btn-primary btn-with-save-bubble w-100 add-to-cart-btn';
                                add_to_cart_btn.innerHTML = `
                                    <div class="save-bubble">${save_bubble_text}</div>
                                    <div class="btn-content">
                                        <div class="btn-main-text">ADD TO CART</div>
                                        <div class="btn-pricing">
                                            <span class="btn-original-price">${compare_price}</span>
                                            <span class="btn-sale-price">${current_price}</span>
                                        </div>
                                    </div>
                                `;
                            } else {
                                // No valid savings - simple button with just current price
                                add_to_cart_btn.className = 'btn-primary w-100 add-to-cart-btn';
                                add_to_cart_btn.innerHTML = `
                                    <span class="text-left">ADD TO CART</span>
                                    <span class="text-right btn-price">${current_price}</span>
                                `;
                            }
                        } else if (price_now_element) {
                            // No compare price - simple button
                            var current_price = price_now_element.textContent.trim();
                            var current_value = parseFloat(current_price.replace(/[^0-9.]/g, ''));
                            
                            // Check if free shipping applies
                            var currency_code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'USD';
                            var country_code = (window.Shopify && window.Shopify.country) ? window.Shopify.country : 'US';
                            var is_usa_user = (currency_code === 'USD' || country_code === 'US');
                            var free_shipping_threshold_cents = 7500; // $75
                            var will_qualify_for_free_shipping = is_usa_user && (current_value * 100) >= free_shipping_threshold_cents;
                            
                            if (will_qualify_for_free_shipping) {
                                add_to_cart_btn.className = 'btn-primary btn-with-save-bubble w-100 add-to-cart-btn';
                                add_to_cart_btn.innerHTML = `
                                    <div class="save-bubble">FREE SHIPPING</div>
                                    <div class="btn-content">
                                        <div class="btn-main-text">ADD TO CART</div>
                                        <div class="btn-pricing">
                                            <span class="btn-sale-price">${current_price}</span>
                                        </div>
                                    </div>
                                `;
                            } else {
                                add_to_cart_btn.className = 'btn-primary w-100 add-to-cart-btn';
                                add_to_cart_btn.innerHTML = `
                                    <span class="text-left">ADD TO CART</span>
                                    <span class="text-right btn-price">${current_price}</span>
                                `;
                            }
                        }
                    }
                }
            });
        });
    }
    bindVariantSelectors('#product-variants');

    // Generic modal triggers (opens a modal by selector; used by Return Policy, etc.)
    document.querySelectorAll('[data-allpa-modal-open]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            var modal = document.querySelector(btn.getAttribute('data-allpa-modal-open'));
            if (modal) { modal.style.display = 'flex'; }
        });
    });

    // Full ingredients modal trigger
    var ingredientsModal = document.querySelector('.full-ingredients-modal');
    if (ingredientsModal) {
        document.querySelectorAll('.full-ingredients-link').forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                ingredientsModal.style.display = 'flex';
            });
        });
    }

    // Shared close behavior for all themed modals (close button + backdrop click)
    document.querySelectorAll('.full-ingredients-modal, .return-policy-modal, .newsletter-signup-modal').forEach(function(modal) {
        var closeBtn = modal.querySelector('.close-btn');
        var backdrop = modal.querySelector('.modal-backdrop');
        if (closeBtn) { closeBtn.addEventListener('click', function() { modal.style.display = 'none'; }); }
        if (backdrop) { backdrop.addEventListener('click', function() { modal.style.display = 'none'; }); }
    });

    // Escape key closes any open themed modal
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            document.querySelectorAll('.full-ingredients-modal, .return-policy-modal, .newsletter-signup-modal').forEach(function(modal) {
                modal.style.display = 'none';
            });
        }
    });

    // Smooth-scroll for in-page quick links (How to Use / FAQs)
    document.querySelectorAll('[data-scroll-to]').forEach(function(link) {
        link.addEventListener('click', function(e) {
            var target = document.querySelector(link.getAttribute('data-scroll-to'));
            if (!target) { return; }
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (history.pushState && link.getAttribute('href')) {
                history.pushState(null, '', link.getAttribute('href'));
            }
        });
    });

    // FAQ accordion functionality
    document.querySelectorAll('.faq-question').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            var faqItem = e.currentTarget.closest('.faq-item');
            if (!faqItem) { return; }
            document.querySelectorAll('.faq-item').forEach(function(item) {
                if (item !== faqItem) { item.classList.remove('active'); }
            });
            faqItem.classList.toggle('active');
        });
    });
});

// Sliding cart
document.addEventListener('DOMContentLoaded', function() {
    var sliding_cart = document.getElementById('sliding-cart');
    var cart_close_btn = document.getElementById('cart-close-btn');
    var cart_overlay = document.querySelector('.cart-overlay');
    var cart_icon = document.querySelector('.cart-icon');
    var checkout_btn = document.querySelector('.btn-checkout');
    var upsell_popup = document.getElementById('upsell-popup');
    
    // Cart state management
    var cart_data = {
        item_count: 0,
        total_price: 0,
        items: []
    };
    
    // Constants
    var FREE_SHIPPING_THRESHOLD_CENTS = 7500; // $75 in cents for USA only
    var PRODUCT_CONFIG_MAP = {
        32: 'VVBTRUxMMzI=',
        37: 'VVBTRUxMMzc=',
        38: 'VVBTRUxMMzg=',
        39: 'VVBTRUxMMzk=',
        43: 'VVBTRUxMNDM='
    };
    
    // Product equivalence classes
    var rosemary_hair_oil_equivalents = ['rosemary-hair-oil', '2-month-supply', '2-months-supply', '3-month-supply', '3-months-supply'];
    var rosemary_shampoo_equivalents = ['rosemary-shampoo', 'rosemary-shampoo-2-pack', 'rosemary-shampoo-3-pack'];
    var rosemary_conditioner_equivalents = ['rosemary-conditioner', 'rosemary-conditioner-2-pack', 'rosemary-conditioner-3-pack'];
    var all_creams = ['soothing-cream', 'energizing-cream', 'rejuvenating-cream'];
    
    var recommendation_chains = {
        TRIO_CHAIN: [
            { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
            { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
        ],
        WASH_DUO_CHAIN: [
            { handle: 'rosemary-hair-oil', description: 'Ready-to-use rosemary oil, no mixing needed' },
            { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
            { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
        ],
        ROSEMARY_CHAIN: [
            { handle: 'rosemary-shampoo', description: 'Clears buildup so your oil absorbs better' },
            { handle: 'rosemary-conditioner', description: 'Less breakage, softer hair after washing' },
            { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
            { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
        ],
        HAIR_OIL_CHAIN: [
            { handle: 'rosemary-shampoo', description: 'Sulfate-free rosemary shampoo for your hair' },
            { handle: 'rosemary-conditioner', description: 'Less breakage, softer hair after washing' },
            { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
            { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
        ],
        FACE_OIL_CHAIN: [
            { handle: 'soothing-cream', description: 'Turmeric and ginger cream for tired muscles' },
            { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
            { handle: 'energizing-cream', description: 'Lavender and orange cream, fast-absorbing' },
            { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
        ],
        CREAM_CHAIN: [
            { handle: 'dynamic-cream-1', description: '' },
            { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
            { handle: 'dynamic-cream-2', description: '' },
            { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
        ],
        BODY_WASH_CHAIN: [
            { handle: 'dynamic-other-body-wash', description: 'Try our other scent' },
            { handle: 'rosemary-shampoo', description: 'Sulfate-free rosemary shampoo for your hair' },
            { handle: 'rosemary-conditioner', description: 'Less breakage, softer hair after washing' }
        ]
    };
    
    // Generate dynamic upsell configurations based on cart contents
    function generate_upsell_configs(cart_handles) {
        var configs = [];
        var selected_chain = null;
        var exclusions = [];
        
        // Check for rosemary hair trio
        if (cart_handles.includes('rosemary-hair-trio')) {
            selected_chain = recommendation_chains.TRIO_CHAIN;
            // Don't recommend rosemary-hair-oil, rosemary-shampoo, or rosemary-conditioner (already in bundle)
            exclusions = exclusions.concat(['rosemary-hair-oil', 'rosemary-shampoo', 'rosemary-conditioner']);
            // Also exclude rosemary hair oil equivalents since trio contains rosemary-hair-oil
            exclusions = exclusions.concat(rosemary_hair_oil_equivalents);
        }
        // Check for rosemary wash duo
        else if (cart_handles.includes('rosemary-wash-duo')) {
            selected_chain = recommendation_chains.WASH_DUO_CHAIN;
            // Don't recommend rosemary-shampoo or rosemary-conditioner (already in bundle)
            exclusions = exclusions.concat(['rosemary-shampoo', 'rosemary-conditioner']);
        }
        else {
            var has_rosemary_equivalent = cart_handles.some(function(handle) {
                return rosemary_hair_oil_equivalents.includes(handle);
            });
            
            // Check for rosemary equivalent
            if (has_rosemary_equivalent) {
                selected_chain = recommendation_chains.ROSEMARY_CHAIN;
                // Exclude all equivalents from recommendations
                exclusions = exclusions.concat(rosemary_hair_oil_equivalents);
            }
            // Check for suffix-based matches (first match wins)
            else {
                // Check for face oils
                var has_face_oil = cart_handles.some(function(handle) {
                    return handle.endsWith('-face-oil');
                });
                
                if (has_face_oil) {
                    selected_chain = recommendation_chains.FACE_OIL_CHAIN;
                }
                else {
                    // Check for other hair oils (exclude bundles ending in -free-hair-oil)
                    var has_other_hair_oil = cart_handles.some(function(handle) {
                        return handle.endsWith('-hair-oil') && !handle.endsWith('-free-hair-oil');
                    });
                    
                    if (has_other_hair_oil) {
                        selected_chain = recommendation_chains.HAIR_OIL_CHAIN;
                    }
                    else {
                        // Check for creams
                        var has_cream = cart_handles.some(function(handle) {
                            return handle.endsWith('-cream');
                        });
                        
                        if (has_cream) {
                            // Dynamic cream chain - find missing creams
                            var missing_creams = all_creams.filter(function(cream) {
                                return !cart_handles.includes(cream);
                            });
                            
                            if (missing_creams.length > 0) {
                                // Create dynamic cream chain
                                var cream_descriptions = {
                                    'soothing-cream': 'Turmeric and ginger cream for tired muscles',
                                    'energizing-cream': 'Lavender and orange cream, fast-absorbing',
                                    'rejuvenating-cream': 'Rosemary and lavender cream, lightweight'
                                };
                                
                                selected_chain = [
                                    { handle: missing_creams[0], description: cream_descriptions[missing_creams[0]] || 'Fast-absorbing, lightweight cream' },
                                    { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' }
                                ];
                                
                                // Add second cream if available
                                if (missing_creams.length > 1) {
                                    selected_chain.push({ handle: missing_creams[1], description: cream_descriptions[missing_creams[1]] || 'Fast-absorbing, lightweight cream' });
                                    selected_chain.push({ handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' });
                                } else {
                                    selected_chain.push({ handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' });
                                }
                            }
                        }
                        else {
                            // Check for shampoos (including dry shampoo)
                            var has_shampoo = cart_handles.some(function(handle) {
                                return handle.endsWith('-shampoo') || handle.endsWith('-dry-shampoo') || rosemary_shampoo_equivalents.includes(handle);
                            });
                            
                            if (has_shampoo) {
                                selected_chain = [
                                    { handle: 'rosemary-conditioner', description: 'Less breakage, softer hair after washing' },
                                    { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
                                    { handle: 'rosemary-hair-oil', description: 'Ready-to-use rosemary oil, no mixing needed' },
                                    { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
                                ];
                                exclusions = exclusions.concat(rosemary_shampoo_equivalents);
                            }
                            else {
                                // Check for conditioners
                                var has_conditioner = cart_handles.some(function(handle) {
                                    return handle.endsWith('-conditioner') || rosemary_conditioner_equivalents.includes(handle);
                                });
                                
                                if (has_conditioner) {
                                    selected_chain = [
                                        { handle: 'rosemary-shampoo', description: 'Sulfate-free rosemary shampoo for your hair' },
                                        { handle: 'rosemary-hair-oil', description: 'Ready-to-use rosemary oil, no mixing needed' },
                                        { handle: 'eucalyptus-peppermint-body-wash', description: 'Cooling eucalyptus and peppermint, sulfate-free' },
                                        { handle: 'lavender-orange-body-wash', description: 'Calming lavender and orange, sulfate-free' }
                                    ];
                                }
                                else {
                                    // Check for body washes
                                    var has_body_wash = cart_handles.some(function(handle) {
                                        return handle.endsWith('-body-wash');
                                    });
                                    
                                    if (has_body_wash) {
                                        // Dynamic body wash chain - find the other body wash
                                        var all_body_washes = ['eucalyptus-peppermint-body-wash', 'lavender-orange-body-wash'];
                                        var missing_body_wash = all_body_washes.find(function(wash) {
                                            return !cart_handles.includes(wash);
                                        });
                                        
                                        if (missing_body_wash) {
                                            selected_chain = [
                                                { handle: missing_body_wash, description: 'Try our other scent' },
                                                { handle: 'rosemary-shampoo', description: 'Sulfate-free rosemary shampoo for your hair' },
                                                { handle: 'rosemary-conditioner', description: 'Less breakage, softer hair after washing' }
                                            ];
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        
        if (cart_handles.some(function(handle) { return rosemary_conditioner_equivalents.includes(handle); })) {
            exclusions = exclusions.concat(rosemary_conditioner_equivalents);
        }

        // Add recommendations from selected chain (return all valid, limit applied after stock check)
        if (selected_chain) {
            var valid_recommendations = [];
            
            // Filter out items already in cart or excluded
            selected_chain.forEach(function(recommendation) {
                if (!cart_handles.includes(recommendation.handle) && !exclusions.includes(recommendation.handle)) {
                    valid_recommendations.push(recommendation);
                }
            });
            
            // Return all valid recommendations (limit to 2 applied in update_upsells_ui after stock filtering)
            valid_recommendations.forEach(function(recommendation) {
                configs.push({
                    handle: recommendation.handle,
                    description: recommendation.description,
                    show_when_missing: [recommendation.handle],
                    show_when_present: []
                });
            });
        }
        
        return configs;
    }
    
    // Store scroll position for restoration
    var saved_scroll_position = 0;
    
    // Open cart functionality
    function open_cart() {
        if (sliding_cart) {
            sliding_cart.classList.add('active');
            
            // Save current scroll position
            saved_scroll_position = window.pageYOffset || document.documentElement.scrollTop;
            
            // Prevent body scrolling when cart is open
            document.body.classList.add('cart-open');
            document.body.style.top = '-' + saved_scroll_position + 'px';
            
            // Add mobile-specific class for touch devices
            if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
                document.body.classList.add('cart-open-mobile');
                
                // Set proper height for mobile cart panel
                var cart_panel = document.querySelector('#sliding-cart .cart-panel');
                if (cart_panel) {
                    // Use window.innerHeight for more reliable mobile height
                    cart_panel.style.height = window.innerHeight + 'px';
                }
            }
        }
    }
    
    // Close cart functionality
    function close_cart() {
        if (sliding_cart) {
            sliding_cart.classList.remove('active');
            
            // Restore body scrolling when cart is closed
            document.body.classList.remove('cart-open');
            document.body.classList.remove('cart-open-mobile');
            document.body.style.top = '';
            
            // Reset cart panel height for mobile
            var cart_panel = document.querySelector('#sliding-cart .cart-panel');
            if (cart_panel) {
                cart_panel.style.height = '';
            }
            
            // Restore scroll position
            window.scrollTo(0, saved_scroll_position);
        }
    }
    
    // Make close_cart globally accessible
    window.close_cart = close_cart;
    
    // Handle window resize for mobile cart height
    window.addEventListener('resize', function() {
        if (sliding_cart && sliding_cart.classList.contains('active')) {
            if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
                var cart_panel = document.querySelector('#sliding-cart .cart-panel');
                if (cart_panel) {
                    cart_panel.style.height = window.innerHeight + 'px';
                }
            }
        }
    });
    
    // Open upsell popup functionality
    function open_upsell_popup() {
        if (upsell_popup) {
            upsell_popup.classList.add('active');
        }
    }
    
    // Close upsell popup functionality
    function close_upsell_popup() {
        if (upsell_popup) {
            upsell_popup.classList.remove('active');
        }
    }
    
    // Format currency using memory preferences [[memory:7705803]] and Shopify currency settings
    function format_currency(amount_in_cents) {
        // Get Shopify's currency information from global variables or cart data
        var currency_code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD';
        var currency_format = window.Shopify && window.Shopify.formatMoney ? window.Shopify.formatMoney : null;
        
        // Use Shopify's formatMoney if available
        if (currency_format && typeof currency_format === 'function') {
            try {
                return currency_format(amount_in_cents).replace('.00', '');
            } catch (e) {
                // Fallback if formatMoney fails
                console.warn('Shopify formatMoney failed, using fallback');
            }
        }
        
        // Fallback: Dynamic currency formatting based on currency code
        var amount = amount_in_cents / 100;
        
        // Handle zero-decimal currencies (JPY, KRW, etc.)
        var zero_decimal_currencies = ['JPY', 'KRW', 'VND', 'CLP', 'ISK', 'TWD'];
        if (zero_decimal_currencies.includes(currency_code)) {
            amount = amount_in_cents; // Don't divide by 100 for these currencies
        }
        
        // Currency symbols mapping
        var currency_symbols = {
            'USD': '$', 'CAD': 'C$', 'EUR': '€', 'GBP': '£', 'AUD': 'A$', 'NZD': 'NZ$',
            'JPY': '¥', 'KRW': '₩', 'CNY': '¥', 'INR': '₹', 'BRL': 'R$', 'MXN': '$',
            'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'CHF': 'CHF', 'PLN': 'zł',
            'CZK': 'Kč', 'HUF': 'Ft', 'RUB': '₽', 'TRY': '₺', 'ZAR': 'R'
        };
        
        var symbol = currency_symbols[currency_code] || currency_code + ' ';
        var decimal_places = zero_decimal_currencies.includes(currency_code) ? 0 : 2;
        var formatted_amount = amount.toFixed(decimal_places);
        
        // Remove .00 for whole numbers (respecting user preference [[memory:7705803]])
        if (decimal_places === 2 && formatted_amount.endsWith('.00')) {
            formatted_amount = formatted_amount.replace('.00', '');
        }
        
        return symbol + formatted_amount;
    }
    
    // Update shipping progress bar - only for USA users
    function update_shipping_progress(cart_total_cents) {
        var shipping_progress_container = document.querySelector('.shipping-progress');
        if (!shipping_progress_container) return;
        
        // Check if user is in USA - free shipping only applies to USA
        var currency_code = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD';
        var country_code = window.Shopify && window.Shopify.country ? window.Shopify.country : 'US';
        
        // Alternative ways to detect USA users
        var is_usa_user = currency_code === 'USD' || country_code === 'US';
        
        // Hide shipping progress for non-USA users
        if (!is_usa_user) {
            shipping_progress_container.style.display = 'none';
            return;
        }
        
        // Show shipping progress for USA users when cart has items
        if (cart_data && cart_data.item_count > 0) {
            shipping_progress_container.style.display = 'block';
        } else {
            // Hide only when cart is completely empty
            shipping_progress_container.style.display = 'none';
            return;
        }
        
        var free_shipping_threshold = FREE_SHIPPING_THRESHOLD_CENTS;
        var remaining = Math.max(0, free_shipping_threshold - cart_total_cents);
        var progress_percentage = Math.min(100, (cart_total_cents / free_shipping_threshold) * 100);
        var is_free_shipping_unlocked = remaining <= 0;
        
        // Reduce progress by 10% when threshold not reached
        var display_progress = is_free_shipping_unlocked ? progress_percentage : Math.max(0, progress_percentage - 10);
        
        var shipping_message = document.getElementById('shipping-message');
        var progress_fill = document.getElementById('shipping-progress-fill');
        var progress_icon = document.querySelector('.progress-icon');
        var progress_icon_svg = document.querySelector('.progress-icon svg');
        
        if (shipping_message) {
            if (is_free_shipping_unlocked) {
                shipping_message.innerHTML = '🎉 <strong>FREE SHIPPING</strong> unlocked!';
            } else {
                shipping_message.innerHTML = 'Add <strong>' + format_currency(remaining) + '</strong> more for <strong>FREE SHIPPING</strong>';
            }
        }
        
        if (progress_fill) {
            progress_fill.style.width = display_progress + '%';
        }
        
        // Update progress icon styling when free shipping is achieved
        if (progress_icon && progress_icon_svg) {
            if (is_free_shipping_unlocked) {
                // Add primary color background and white text
                progress_icon.style.backgroundColor = 'var(--primary-color)';
                progress_icon.style.color = 'var(--text-white)';
                progress_icon_svg.style.color = 'var(--text-white)';
            } else {
                // Reset to default styling
                progress_icon.style.backgroundColor = '';
                progress_icon.style.color = '';
                progress_icon_svg.style.color = '';
            }
        }
    }
    
    // Update cart count in header (total quantity of all items)
    function update_cart_count(cart) {
        // Use total item count (includes quantities)
        var total_item_count = 0;
        
        if (typeof cart === 'object' && cart !== null) {
            total_item_count = cart.item_count || 0;
            
            // Manual calculation as backup
            var manual_count = 0;
            if (cart.items) {
                cart.items.forEach(function(item) {
                    manual_count += item.quantity || 0;
                });
            }
            
            // Use manual count if it's different from item_count (indicating a bundle issue)
            if (manual_count !== total_item_count && manual_count > 0) {
                total_item_count = manual_count;
            }
        } else {
            total_item_count = cart || 0;
        }
        
        var cart_count_element = document.getElementById('cart-count');
        if (cart_count_element) {
            cart_count_element.textContent = total_item_count;
        }
        
        // Update cart count bubble
        var cart_count_bubble = document.getElementById('cart-count-bubble');
        if (cart_count_bubble) {
            cart_count_bubble.textContent = total_item_count;
            cart_count_bubble.setAttribute('data-count', total_item_count);
            
            // Show/hide bubble based on count
            if (total_item_count === 0) {
                cart_count_bubble.style.display = 'none';
            } else {
                cart_count_bubble.style.display = 'flex';
            }
        }
        
        // Update any other cart count elements
        var cart_count_elements = document.querySelectorAll('.cart-count');
        cart_count_elements.forEach(function(element) {
            element.textContent = total_item_count;
        });
    }
    
    // Fetch current cart data from Shopify
    function fetch_cart() {
        return fetch('/cart.js')
            .then(function(response) {
                return response.json();
            })
            .then(function(cart) {
                cart_data = cart;
                update_cart_count(cart);
                update_shipping_progress(cart.items_subtotal_price || cart.total_price);
                
                // Check if discount code should be removed when cart is fetched
                return check_and_remove_discount_if_needed(cart);
            })
            .then(function(updated_cart) {
                // Update UI with the potentially updated cart (after discount removal)
                update_cart_items_ui(updated_cart);
                update_upsells_ui(updated_cart);
                update_checkout_button_with_savings(updated_cart);
                return updated_cart;
            })
        .catch(function(error) {
            console.error('Error fetching cart:', error);
            // Return empty cart object to prevent unhandled promise rejection
            return {
                item_count: 0,
                total_price: 0,
                items: [],
                discount_codes: []
            };
        });
    }
    
    // Add item to cart
    function add_to_cart(variant_id, quantity, properties) {
        var data = {
            id: variant_id,
            quantity: quantity || 1
        };
        
        if (properties) {
            data.properties = properties;
        }
        
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(item) {
            // Refresh cart after adding item
            refresh_cart_ui();
            // Force show shipping progress when item is added
            var shipping_progress_container = document.querySelector('.shipping-progress');
            if (shipping_progress_container) {
                shipping_progress_container.style.display = 'block';
            }
            open_cart();
            return item;
        })
        .catch(function(error) {
            console.error('Error adding to cart:', error);
            alert('Sorry, there was an error adding this item to your cart.');
        });
    }
    
    // Add item to cart silently (without opening cart)
    function add_to_cart_silent(variant_id, quantity, properties) {
        var data = {
            id: variant_id,
            quantity: quantity || 1
        };
        
        if (properties) {
            data.properties = properties;
        }
        
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(item) {
            return fetch_cart().then(function(cart) {
                update_cart_count(cart);
                update_shipping_progress(cart.items_subtotal_price || cart.total_price);
                var shipping_progress_container = document.querySelector('.shipping-progress');
                if (shipping_progress_container) {
                    shipping_progress_container.style.display = 'block';
                }
                
                return check_and_remove_discount_if_needed(cart);
            }).then(function(updated_cart) {
                update_cart_items_ui(updated_cart);
                update_upsells_ui(updated_cart);
                update_checkout_button_with_savings(updated_cart);
                return item;
            });
        })
        .catch(function(error) {
            console.error('Error adding to cart:', error);
            // Return null to indicate failure instead of throwing
            return null;
        });
    }
    
    // Add item to cart with discount (for upsell popup)
    function add_to_cart_with_discount(variant_id, quantity, original_price, properties) {
        var enhanced_properties = properties || {};
        enhanced_properties['_upsell_item'] = 'true';
        enhanced_properties['_discount_applied'] = 'true';
        enhanced_properties['_original_price'] = format_currency(original_price);
        
        return add_to_cart(variant_id, quantity, enhanced_properties)
            .then(function() {
                return apply_upsell_discount_code(original_price);
            });
    }
    
    // Apply upsell discount using product configuration
    function apply_upsell_discount_code(product_price) {
        var config_string = get_discount_code_for_price(product_price);
        
        if (!config_string) {
            console.warn('No product configuration found for price:', product_price);
            return Promise.resolve();
        }
        
        // Process configuration string
        var discount_code = decode_product_config(config_string);
        
        if (!discount_code) {
            console.warn('Failed to process product configuration');
            return Promise.resolve();
        }
        
        return apply_discount_code(discount_code)
            .then(function() {
                // Store discount info for tracking
                try {
                    sessionStorage.setItem('upsell_discount_applied', discount_code);
                    sessionStorage.setItem('upsell_original_price', product_price);
                } catch (e) {
                    // Ignore storage errors
                }
                return Promise.resolve();
            });
    }
    
    
    // Get product configuration for price
    function get_discount_code_for_price(price_in_cents) {
        var price_in_dollars = price_in_cents / 100;
        return PRODUCT_CONFIG_MAP[price_in_dollars] || null;
    }
    
    // Process product configuration
    function decode_product_config(config_string) {
        try {
            // Transform configuration string
            var processed = atob(config_string);
            return processed;
        } catch (e) {
            console.warn('Error processing configuration:', e);
            return null;
        }
    }
    
    // Apply discount code to checkout
    function apply_discount_code(code) {
        console.log('Attempting to apply discount code:', code);
        
        // Validate input
        if (!code || typeof code !== 'string') {
            console.error('Invalid discount code provided:', code);
            return Promise.resolve(false);
        }
        
        // Method 1: Try redirecting to checkout with discount code
        var checkout_url = '/checkout?discount=' + encodeURIComponent(code);
        console.log('Checkout URL with discount:', checkout_url);
        
        // Store the discount code for the checkout redirect
        try {
            sessionStorage.setItem('pending_discount_code', code);
            sessionStorage.setItem('discount_redirect_url', checkout_url);
            return Promise.resolve(true);
        } catch (e) {
            console.warn('Could not store discount info:', e);
            return Promise.resolve(false);
        }
    }
    
    // Check if any cart items have upsell discount properties
    function has_upsell_discount_products(cart) {
        if (!cart || !cart.items) return false;
        
        return cart.items.some(function(item) {
            if (!item.properties) return false;
            
            // Check for upsell discount properties
            return item.properties['_upsell_item'] === 'true' || 
                   item.properties['_upsell_discount'] || 
                   item.properties['_discount_applied'] === 'true';
        });
    }
    
    // Remove discount code from cart using Shopify cart API
    function remove_discount_code_from_cart() {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                discount: '' // Empty string removes the discount code
            })
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(cart) {
            return cart;
        })
        .catch(function(error) {
            console.error('Error removing discount code from cart:', error);
            throw error;
        });
    }
    
    // Remove discount code from session storage and clear discount-related data
    function remove_discount_code() {
        try {
            // Clear all discount-related session storage
            sessionStorage.removeItem('upsell_discount_applied');
            sessionStorage.removeItem('upsell_original_price');
            sessionStorage.removeItem('pending_discount_code');
            sessionStorage.removeItem('discount_redirect_url');
            
            console.log('Discount code and related data removed from session storage');
        } catch (e) {
            console.warn('Could not clear discount data from session storage:', e);
        }
    }
    
    // The set of codes the upsell flow can apply (decoded from PRODUCT_CONFIG_MAP).
    // Only these are ever ours to remove.
    function get_upsell_discount_codes() {
        return Object.keys(PRODUCT_CONFIG_MAP).map(function(price) {
            return decode_product_config(PRODUCT_CONFIG_MAP[price]);
        }).filter(function(code) {
            return !!code;
        }).map(function(code) {
            return code.toUpperCase();
        });
    }
    
    function is_upsell_discount_code(code) {
        return !!code && get_upsell_discount_codes().indexOf(String(code).toUpperCase()) !== -1;
    }
    
    // Check and remove the UPSELL discount code if no upsell products are present.
    // IMPORTANT: only touches codes the upsell flow itself applied. A code the
    // customer entered or got from a sale email must never be stripped, and
    // /cart/update.js with discount:'' clears ALL codes, so it is only called
    // when every applied code is one of ours.
    function check_and_remove_discount_if_needed(cart) {
        var has_upsell_products = has_upsell_discount_products(cart);
        if (has_upsell_products) {
            return Promise.resolve(cart);
        }
        
        var has_discount_in_storage = sessionStorage.getItem('upsell_discount_applied') || sessionStorage.getItem('pending_discount_code');
        var cart_codes = (cart && Array.isArray(cart.discount_codes)) ? cart.discount_codes : [];
        var cart_upsell_codes = cart_codes.filter(function(d) {
            return d && is_upsell_discount_code(d.code);
        });
        var cart_has_only_upsell_codes = cart_codes.length > 0 && cart_upsell_codes.length === cart_codes.length;
        
        // Session storage only ever holds upsell data - always safe to clear.
        if (has_discount_in_storage) {
            remove_discount_code();
        }
        
        if (cart_has_only_upsell_codes) {
            // Cart-applied code(s) are all ours and the upsell item is gone - remove.
            return remove_discount_code_from_cart()
                .then(function(updated_cart) {
                    return updated_cart;
                })
                .catch(function(error) {
                    console.error('Failed to remove discount code from cart:', error);
                    return cart;
                });
        }
        
        return Promise.resolve(cart);
    }
    
    
    // Update cart item quantity
    function update_cart_item(key, quantity) {
        var data = {
            updates: {}
        };
        data.updates[key] = quantity;
        
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        .then(function(response) {
            return response.json();
        })
        .then(function(cart) {
            cart_data = cart;
            update_cart_count(cart);
            update_shipping_progress(cart.items_subtotal_price || cart.total_price);
            // Force show shipping progress when cart is updated (including item removal)
            var shipping_progress_container = document.querySelector('.shipping-progress');
            if (shipping_progress_container && cart.item_count > 0) {
                shipping_progress_container.style.display = 'block';
            }
            
            // Check if discount code should be removed when cart is updated
            return check_and_remove_discount_if_needed(cart);
        })
        .then(function(updated_cart) {
            // Update UI with the potentially updated cart (after discount removal)
            update_cart_items_ui(updated_cart);
            update_upsells_ui(updated_cart);
            update_checkout_button_with_savings(updated_cart);
            return updated_cart;
        })
        .catch(function(error) {
            console.error('Error updating cart:', error);
            // Return current cart data to prevent undefined return
            return cart_data || { item_count: 0, total_price: 0, items: [] };
        });
    }
    
    // Remove item from cart
    function remove_cart_item(key) {
        return update_cart_item(key, 0);
    }
    
    // Refresh cart UI with current data
    function refresh_cart_ui() {
        // Fetch fresh cart data and update UI dynamically
        fetch('/cart.js')
            .then(function(response) {
                return response.json();
            })
            .then(function(cart) {
                cart_data = cart;
                update_cart_count(cart);
                update_shipping_progress(cart.items_subtotal_price || cart.total_price);
                // Force show shipping progress when cart is refreshed and has items
                var shipping_progress_container = document.querySelector('.shipping-progress');
                if (shipping_progress_container && cart.item_count > 0) {
                    shipping_progress_container.style.display = 'block';
                }
                
                // Check if discount code should be removed when cart is refreshed
                return check_and_remove_discount_if_needed(cart);
            })
            .then(function(updated_cart) {
                // Update UI with the potentially updated cart (after discount removal)
                update_cart_items_ui(updated_cart);
                update_upsells_ui(updated_cart);
                update_checkout_button_with_savings(updated_cart);
            })
            .catch(function(error) {
                console.error('Error refreshing cart UI:', error);
                // Update UI with current cart data as fallback
                if (cart_data) {
                    update_cart_items_ui(cart_data);
                    update_upsells_ui(cart_data);
                    update_checkout_button_with_savings(cart_data);
                }
            });
    }
    
    // Update cart items in the UI
    function update_cart_items_ui(cart) {
        var cart_items_container = document.getElementById('cart-items');
        if (!cart_items_container) return;
        
        // Update shipping progress visibility based on cart state
        var shipping_progress_container = document.querySelector('.shipping-progress');
        if (shipping_progress_container) {
            if (cart.item_count === 0) {
                shipping_progress_container.style.display = 'none';
            } else {
                shipping_progress_container.style.display = 'block';
            }
        }
        
        if (cart.item_count === 0) {
            cart_items_container.classList.remove('has-items');
            cart_items_container.classList.add('is-empty');
            cart_items_container.innerHTML = `
                <div class="empty-cart text-center">
                    <p>Your cart is empty</p>
                    <button class="btn-primary" onclick="close_cart()">Continue Shopping</button>
                </div>
            `;
            return;
        }
        
        // When cart has items, update classes
        cart_items_container.classList.remove('is-empty');
        cart_items_container.classList.add('has-items');
        
        // Fetch variant data for all items to get compare_at_price
        var variant_promises = cart.items.map(function(item) {
            // Try different approaches to get product data
            var product_url = '';
            if (item.handle) {
                product_url = `/products/${item.handle}.js`;
            } else if (item.product_handle) {
                product_url = `/products/${item.product_handle}.js`;
            } else if (item.url) {
                // Extract handle from URL like /products/product-handle
                var url_parts = item.url.split('/products/');
                if (url_parts.length > 1 && url_parts[1]) {
                    var handle = url_parts[1].split('?')[0]; // Remove query parameters
                    if (handle) {
                        product_url = `/products/${handle}.js`;
                    }
                }
            } else {
                console.warn('No handle found for item:', item);
                return Promise.resolve({
                    item: item,
                    variant: null
                });
            }
            
            return fetch(product_url)
                .then(function(response) {
                    if (!response.ok) {
                        throw new Error('Product not found: ' + response.status);
                    }
                    return response.json();
                })
                .then(function(product) {
                    var variant = product.variants.find(function(v) {
                        return v.id === item.variant_id;
                    });
                    return {
                        item: item,
                        variant: variant
                    };
                })
                .catch(function(error) {
                    console.error('Error fetching variant data for item:', item.product_title, error);
                    return {
                        item: item,
                        variant: null
                    };
                });
        });
        
        Promise.all(variant_promises).then(function(items_with_variants) {
            var items_html = '';
            var total_original_price = 0;
            var total_current_price = 0;
            
            // Enhance cart items with variant data for checkout button calculation
            cart.items.forEach(function(cart_item, index) {
                if (items_with_variants[index] && items_with_variants[index].variant) {
                    cart_item.variant = items_with_variants[index].variant;
                }
            });
            
            items_with_variants.forEach(function(data) {
                var item = data.item;
                var variant = data.variant;
                
                var image_html = '';
                if (item.image) {
                    image_html = `<a href="${item.url}"><img src="${item.image}" alt="${item.product_title}" class="img-fluid" width="80" height="80"></a>`;
                } else {
                    image_html = `<a href="${item.url}"><div class="placeholder-image" style="width: 80px; height: 80px; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999;">No Image</div></a>`;
                }
                
                var subscription_html = '';
                if (item.selling_plan_allocation) {
                    subscription_html = `
                        <p class="item-subscription">
                            <span class="subscription-badge">📅</span>
                            ${item.selling_plan_allocation.selling_plan.name}
                        </p>
                    `;
                }
                
                // Calculate prices using variant compare_at_price OR subscription savings
                var current_line_price = item.final_line_price || item.line_price || (item.price * item.quantity);
                var original_line_price = 0;
                var original_price_html = '';
                
                // Priority 1: Check for subscription savings (subscription price vs regular price)
                if (item.selling_plan_allocation && variant && variant.price > item.price) {
                    // Subscription item: show regular price as "original" and subscription price as current
                    original_line_price = variant.price * item.quantity;
                    original_price_html = `<span class="original-price">${format_currency(original_line_price)}</span>`;
                } 
                // Priority 2: Check for regular product discount (compare_at_price)
                else if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
                    original_line_price = variant.compare_at_price * item.quantity;
                    original_price_html = `<span class="original-price">${format_currency(original_line_price)}</span>`;
                } 
                // Priority 3: Fallback to cart API data if available
                else if (item.original_line_price && item.original_line_price > current_line_price) {
                    original_line_price = item.original_line_price;
                    original_price_html = `<span class="original-price">${format_currency(original_line_price)}</span>`;
                } 
                // Priority 4: Fallback to original unit price
                else if (item.original_price && item.original_price > item.price) {
                    original_line_price = item.original_price * item.quantity;
                    original_price_html = `<span class="original-price">${format_currency(original_line_price)}</span>`;
                }
                
                // Add to totals for checkout button calculation
                total_current_price += current_line_price;
                total_original_price += original_line_price || current_line_price;
                
                items_html += `
                    <div class="cart-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
                        <div class="item-image">
                            ${image_html}
                        </div>
                        <div class="item-details">
                            <h4 class="item-name"><a href="${item.url}">${item.product_title}</a></h4>
                            ${subscription_html}
                            <div class="item-controls">
                                <div class="quantity-controls">
                                    <button class="qty-btn qty-decrease" data-key="${item.key}">-</button>
                                    <span class="qty-value">${item.quantity}</span>
                                    <button class="qty-btn qty-increase" data-key="${item.key}">+</button>
                                </div>
                                <div class="item-price">
                                    ${original_price_html}
                                    <span class="current-price">${format_currency(current_line_price)}</span>
                                </div>
                            </div>
                        </div>
                        <button class="item-remove" data-key="${item.key}">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="3,6 5,6 21,6"></polyline>
                                <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                <line x1="14" y1="11" x2="14" y2="17"></line>
                            </svg>
                        </button>
                    </div>
                `;
            });
            
            cart_items_container.innerHTML = items_html;
            
            // Update checkout button with cart totals (includes promo codes)
            update_checkout_button_with_savings(cart);
            update_upsells_ui(cart);
            
            // Update shipping progress after all async operations complete
            update_shipping_progress(cart.items_subtotal_price || cart.total_price);
        }).catch(function(error) {
            console.error('Error updating cart items UI:', error);
            // Fallback to simple cart display without compare prices
            render_simple_cart_items(cart);
        });
    }
    
    // Fallback simple cart rendering without compare prices
    function render_simple_cart_items(cart) {
        var cart_items_container = document.getElementById('cart-items');
        if (!cart_items_container) return;
        
        // Update shipping progress visibility based on cart state
        var shipping_progress_container = document.querySelector('.shipping-progress');
        if (shipping_progress_container) {
            if (cart.item_count === 0) {
                shipping_progress_container.style.display = 'none';
            } else {
                shipping_progress_container.style.display = 'block';
            }
        }
        
        if (cart.item_count === 0) {
            cart_items_container.classList.remove('has-items');
            cart_items_container.classList.add('is-empty');
            cart_items_container.innerHTML = `
                <div class="empty-cart text-center">
                    <p>Your cart is empty</p>
                    <button class="btn-primary" onclick="close_cart()">Continue Shopping</button>
                </div>
            `;
            return;
        }
        
        // When cart has items, update classes
        cart_items_container.classList.remove('is-empty');
        cart_items_container.classList.add('has-items');
        
        var items_html = '';
        cart.items.forEach(function(item) {
            var image_html = '';
            if (item.image) {
                image_html = `<a href="${item.url}"><img src="${item.image}" alt="${item.product_title}" class="img-fluid" width="80" height="80"></a>`;
            } else {
                image_html = `<a href="${item.url}"><div class="placeholder-image" style="width: 80px; height: 80px; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999;">No Image</div></a>`;
            }
            
            var subscription_html = '';
            if (item.selling_plan_allocation) {
                subscription_html = `
                    <p class="item-subscription">
                        <span class="subscription-badge">📅</span>
                        ${item.selling_plan_allocation.selling_plan.name}
                    </p>
                `;
            }
            
            var current_line_price = item.final_line_price || item.line_price || (item.price * item.quantity);
            
            items_html += `
                <div class="cart-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
                    <div class="item-image">
                        ${image_html}
                    </div>
                    <div class="item-details">
                        <h4 class="item-name"><a href="${item.url}">${item.product_title}</a></h4>
                        ${subscription_html}
                        <div class="item-controls">
                            <div class="quantity-controls">
                                <button class="qty-btn qty-decrease" data-key="${item.key}">-</button>
                                <span class="qty-value">${item.quantity}</span>
                                <button class="qty-btn qty-increase" data-key="${item.key}">+</button>
                            </div>
                            <div class="item-price">
                                <span class="current-price">${format_currency(current_line_price)}</span>
                            </div>
                        </div>
                    </div>
                    <button class="item-remove" data-key="${item.key}">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="3,6 5,6 21,6"></polyline>
                            <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                            <line x1="10" y1="11" x2="10" y2="17"></line>
                            <line x1="14" y1="11" x2="14" y2="17"></line>
                        </svg>
                    </button>
                </div>
            `;
        });
        
        cart_items_container.innerHTML = items_html;
        update_checkout_button_with_savings(cart);
        update_upsells_ui(cart);
        
        // Update shipping progress in fallback too
        update_shipping_progress(cart.items_subtotal_price || cart.total_price);
    }
    
    // Update checkout button with cart totals (includes promo code discounts)
    function update_checkout_button_with_savings(cart) {
        var checkout_container = document.querySelector('.cart-checkout');
        if (!checkout_container) return;
        
        if (!cart || cart.item_count === 0) {
            checkout_container.style.display = 'none';
            return;
        }
        
        checkout_container.style.display = 'block';
        
        // Calculate total savings combining individual item discounts AND promo code discounts
        var calculated_original_total = 0;
        var current_total = cart.total_price; // This includes promo code discounts
        
        // Calculate original total from individual items (includes compare_at_price, subscription savings)
        if (cart.items) {
            cart.items.forEach(function(item) {
                var item_original_price = 0;
                
                // Priority 1: Check for subscription savings (subscription price vs regular price)
                if (item.selling_plan_allocation && item.variant && item.variant.price > item.price) {
                    item_original_price = item.variant.price * item.quantity;
                } 
                // Priority 2: Check for regular product discount (compare_at_price)
                else if (item.variant && item.variant.compare_at_price && item.variant.compare_at_price > item.variant.price) {
                    item_original_price = item.variant.compare_at_price * item.quantity;
                } 
                // Priority 3: Fallback to cart API data if available
                else if (item.original_line_price && item.original_line_price > item.final_line_price) {
                    item_original_price = item.original_line_price;
                } 
                // Priority 4: Use current price as original (no individual discount)
                else {
                    item_original_price = item.final_line_price || (item.price * item.quantity);
                }
                
                calculated_original_total += item_original_price;
            });
        }
        
        // Total savings = individual item discounts + promo code discounts
        var total_savings = calculated_original_total - current_total;
        var original_total = calculated_original_total;
        
        // Check if adding this order will qualify for free shipping (USA users only)
        var currency_code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'USD';
        var country_code = (window.Shopify && window.Shopify.country) ? window.Shopify.country : 'US';
        var is_usa_user = (currency_code === 'USD' || country_code === 'US');
        var free_shipping_threshold = FREE_SHIPPING_THRESHOLD_CENTS;
        var will_qualify_for_free_shipping = is_usa_user && current_total >= free_shipping_threshold;
        
        var checkout_html = '';
        if (total_savings > 0) {
            var save_bubble_text = 'SAVE ' + format_currency(total_savings);
            if (will_qualify_for_free_shipping) {
                save_bubble_text += ' + FREE SHIPPING';
            }
            checkout_html = `
                <button class="btn-primary btn-with-save-bubble btn-checkout">
                    <div class="save-bubble">${save_bubble_text}</div>
                    <div class="btn-content">
                        <div class="btn-main-text">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <circle cx="12" cy="16" r="1"></circle>
                                <path d="m7 11 V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            SECURE CHECKOUT
                        </div>
                        <div class="btn-pricing">
                            <span class="btn-original-price">${format_currency(original_total)}</span>
                            <span class="btn-sale-price">${format_currency(current_total)}</span>
                        </div>
                    </div>
                </button>
            `;
        } else if (will_qualify_for_free_shipping) {
            // Show free shipping bubble even when there are no savings
            checkout_html = `
                <button class="btn-primary btn-with-save-bubble btn-checkout">
                    <div class="save-bubble">FREE SHIPPING</div>
                    <div class="btn-content">
                        <div class="btn-main-text">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <circle cx="12" cy="16" r="1"></circle>
                                <path d="m7 11 V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            SECURE CHECKOUT
                        </div>
                        <div class="btn-pricing">
                            <span class="btn-sale-price">${format_currency(current_total)}</span>
                        </div>
                    </div>
                </button>
            `;
        } else {
            checkout_html = `
                <button class="btn-primary btn-checkout">
                    <div class="btn-content">
                        <div class="btn-main-text">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <circle cx="12" cy="16" r="1"></circle>
                                <path d="m7 11 V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            SECURE CHECKOUT
                        </div>
                        <div class="btn-pricing">
                            <span class="btn-sale-price">${format_currency(current_total)}</span>
                        </div>
                    </div>
                </button>
            `;
        }
        
        checkout_container.innerHTML = checkout_html;
    }

    
    // Update upsells based on current cart - dynamically render
    function update_upsells_ui(cart) {
        var upsells_container = document.querySelector('.cart-upsells');
        if (!upsells_container) return;
        
        // Get current cart product handles
        var cart_handles = [];
        if (cart.items) {
            cart.items.forEach(function(item) {
                // Extract handle from different possible sources
                var handle = null;
                
                if (item.handle) {
                    handle = item.handle;
                } else if (item.product && item.product.handle) {
                    handle = item.product.handle;
                } else if (item.url) {
                    // Extract handle from URL like /products/product-handle
                    var url_parts = item.url.split('/products/');
                    if (url_parts.length > 1) {
                        handle = url_parts[1].split('?')[0]; // Remove query parameters
                    }
                } else if (item.product_handle) {
                    handle = item.product_handle;
                }
                
                if (handle) {
                    cart_handles.push(handle);
                }
            });
        }
        
        // Generate dynamic upsell configurations based on current cart
        var upsell_configs = generate_upsell_configs(cart_handles);
        
        // Process upsell configurations to find active upsells
        var active_upsells = [];
        
        upsell_configs.forEach(function(config) {
            var should_show = true;
            
            // Check show_when_missing conditions
            if (config.show_when_missing && config.show_when_missing.length > 0) {
                config.show_when_missing.forEach(function(missing_handle) {
                    if (cart_handles.includes(missing_handle)) {
                        should_show = false;
                    }
                });
            }
            
            // Check show_when_present conditions
            if (should_show && config.show_when_present && config.show_when_present.length > 0) {
                var has_required = config.show_when_present.some(function(required_handle) {
                    return cart_handles.includes(required_handle);
                });
                if (!has_required) {
                    should_show = false;
                }
            }
            
            if (should_show) {
                active_upsells.push(config);
            }
        });
        
        // Hide entire container if no active upsells or cart is empty
        if (active_upsells.length === 0 || cart.item_count === 0) {
            upsells_container.style.display = 'none';
            return;
        }
        
        // Fetch product data for all active upsells and render
        var product_promises = active_upsells.map(function(config) {
            return fetch('/products/' + config.handle + '.js')
                .then(function(response) {
                    if (!response.ok) {
                        throw new Error('Product not found: ' + config.handle);
                    }
                    return response.json();
                })
                .then(function(product) {
                    return {
                        config: config,
                        product: product
                    };
                })
                .catch(function(error) {
                    console.warn('Could not fetch upsell product:', config.handle, error);
                    return null;
                });
        });
        
        Promise.all(product_promises).then(function(results) {
            // Filter out failed requests and products with "Out of Stock" tag
            var valid_upsells = results.filter(function(result) {
                if (result === null) return false;
                
                // Check if product has "Out of Stock" tag
                var product = result.product;
                if (product && product.tags) {
                    var has_out_of_stock_tag = product.tags.some(function(tag) {
                        return tag.toLowerCase() === 'out of stock';
                    });
                    
                    if (has_out_of_stock_tag) {
                        return false;
                    }
                }
                
                return true;
            });
            
            if (valid_upsells.length === 0) {
                upsells_container.style.display = 'none';
                return;
            }
            
            // Limit to maximum 2 upsells (applied after stock filtering)
            valid_upsells = valid_upsells.slice(0, 2);
            
            // Generate HTML for upsells
            var upsells_html = `
                <h4 class="upsells-title">Pairs Well With</h4>
                <div class="upsell-items">
            `;
            
            valid_upsells.forEach(function(data) {
                var config = data.config;
                var product = data.product;
                var variant = product.variants[0]; // Use first variant
                
                var image_html = '';
                // Add scale style for cream products
                var image_style = product.handle.includes('-cream') ? ' style="scale: 1 !important;"' : '';
                
                if (product.featured_image) {
                    image_html = `<a href="${product.url}"><img src="${product.featured_image}" alt="${product.title}" class="img-fluid" width="60" height="60"${image_style}></a>`;
                } else {
                    image_html = `<a href="${product.url}"><div class="placeholder-image" style="width: 60px; height: 60px; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999; font-size: 10px;">No Image</div></a>`;
                }
                
                var price_html = '';
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    price_html = `
                        <span class="original-price">${format_currency(variant.compare_at_price)}</span>
                        <span class="current-price">${format_currency(variant.price)}</span>
                    `;
                } else {
                    price_html = `<span class="current-price">${format_currency(variant.price)}</span>`;
                }
                
                upsells_html += `
                    <div class="upsell-item" data-product-handle="${config.handle}">
                        <div class="upsell-image">
                            ${image_html}
                        </div>
                        <div class="upsell-details">
                            <h5 class="upsell-name"><a href="${product.url}">${product.title}</a></h5>
                            <p class="upsell-description">${config.description}</p>
                            <div class="upsell-price">
                                ${price_html}
                            </div>
                        </div>
                        <button class="upsell-add-btn" data-variant-id="${variant.id}">Add +</button>
                    </div>
                `;
            });
            
            upsells_html += '</div>';
            
            // Update container content and show
            upsells_container.innerHTML = upsells_html;
            upsells_container.style.display = 'block';
            
        }).catch(function(error) {
            console.error('Error updating upsells UI:', error);
            upsells_container.style.display = 'none';
        });
    }
    
    // Show loading state for cart item
    function show_item_loading(cart_item_element, type) {
        if (type === 'quantity') {
            var qty_controls = cart_item_element.querySelector('.quantity-controls');
            if (qty_controls) {
                qty_controls.style.opacity = '0.5';
                qty_controls.style.pointerEvents = 'none';
                
                // Add spinner to quantity value
                var qty_value = qty_controls.querySelector('.qty-value');
                if (qty_value) {
                    qty_value.innerHTML = '<span class="btn-spinner" style="width: 14px; height: 14px; border-width: 2px; margin: 0 auto; display: inline-block; vertical-align: middle;"></span>';
                }
            }
        } else if (type === 'remove') {
            var remove_btn = cart_item_element.querySelector('.item-remove');
            if (remove_btn) {
                remove_btn.style.opacity = '0.5';
                remove_btn.style.pointerEvents = 'none';
                remove_btn.innerHTML = '<span class="btn-spinner" style="width: 14px; height: 14px; border-width: 2px; margin: 0 auto; display: inline-block; vertical-align: middle;"></span>';
            }
            
            // Fade out the entire item
            cart_item_element.style.opacity = '0.7';
            cart_item_element.style.pointerEvents = 'none';
        }
    }
    
    // Hide loading state for cart item
    function hide_item_loading(cart_item_element, type, original_quantity) {
        if (type === 'quantity') {
            var qty_controls = cart_item_element.querySelector('.quantity-controls');
            if (qty_controls) {
                qty_controls.style.opacity = '';
                qty_controls.style.pointerEvents = '';
                
                // Restore quantity value
                var qty_value = qty_controls.querySelector('.qty-value');
                if (qty_value && original_quantity) {
                    qty_value.textContent = original_quantity;
                }
            }
        }
        // For remove operations, we don't need to hide loading since the item will be removed from DOM
    }

    // Handle quantity button clicks
    function handle_quantity_buttons() {
        // Quantity increase buttons
        document.addEventListener('click', function(e) {
            if (e.target.classList.contains('qty-increase')) {
                var key = e.target.getAttribute('data-key');
                var cart_item = e.target.closest('.cart-item');
                var qty_element = e.target.parentNode.querySelector('.qty-value');
                var current_qty = parseInt(qty_element.textContent);
                var new_qty = current_qty + 1;
                
                // Show loading state
                show_item_loading(cart_item, 'quantity');
                
                update_cart_item(key, new_qty)
                    .catch(function(error) {
                        // Restore on error
                        hide_item_loading(cart_item, 'quantity', current_qty);
                        console.error('Error updating quantity:', error);
                    });
            }
        });
        
        // Quantity decrease buttons
        document.addEventListener('click', function(e) {
            if (e.target.classList.contains('qty-decrease')) {
                var key = e.target.getAttribute('data-key');
                var cart_item = e.target.closest('.cart-item');
                var qty_element = e.target.parentNode.querySelector('.qty-value');
                var current_qty = parseInt(qty_element.textContent);
                
                if (current_qty > 1) {
                    var new_qty = current_qty - 1;
                    
                    // Show loading state
                    show_item_loading(cart_item, 'quantity');
                    
                    update_cart_item(key, new_qty)
                        .catch(function(error) {
                            // Restore on error
                            hide_item_loading(cart_item, 'quantity', current_qty);
                            console.error('Error updating quantity:', error);
                        });
                } else if (current_qty === 1) {
                    // Remove item when quantity would go from 1 to 0
                    show_item_loading(cart_item, 'remove');
                    
                    remove_cart_item(key)
                        .catch(function(error) {
                            // Restore on error
                            cart_item.style.opacity = '';
                            cart_item.style.pointerEvents = '';
                            var remove_btn = cart_item.querySelector('.item-remove');
                            if (remove_btn) {
                                remove_btn.style.opacity = '';
                                remove_btn.style.pointerEvents = '';
                                remove_btn.innerHTML = `
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <polyline points="3,6 5,6 21,6"></polyline>
                                        <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                                        <line x1="10" y1="11" x2="10" y2="17"></line>
                                        <line x1="14" y1="11" x2="14" y2="17"></line>
                                    </svg>
                                `;
                            }
                            console.error('Error removing item:', error);
                        });
                }
            }
        });
        
        // Remove item buttons
        document.addEventListener('click', function(e) {
            if (e.target.classList.contains('item-remove') || e.target.closest('.item-remove')) {
                var button = e.target.classList.contains('item-remove') ? e.target : e.target.closest('.item-remove');
                var key = button.getAttribute('data-key');
                var cart_item = button.closest('.cart-item');
                
                // Show loading state immediately (no confirmation)
                show_item_loading(cart_item, 'remove');
                
                remove_cart_item(key)
                    .catch(function(error) {
                        // Restore on error
                        cart_item.style.opacity = '';
                        cart_item.style.pointerEvents = '';
                        var remove_btn = cart_item.querySelector('.item-remove');
                        if (remove_btn) {
                            remove_btn.style.opacity = '';
                            remove_btn.style.pointerEvents = '';
                            remove_btn.innerHTML = `
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="3,6 5,6 21,6"></polyline>
                                    <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                            `;
                        }
                        console.error('Error removing item:', error);
                    });
            }
        });
    }
    
    // Show add to cart success feedback
    function show_add_to_cart_feedback(button) {
        // Change button to success state with SVG checkmark
        button.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20,6 9,17 4,12"></polyline></svg>';
        button.style.backgroundColor = 'var(--primary-color)';
        button.style.borderColor = 'var(--primary-color)';
        button.style.color = 'var(--text-white)';
        
        // Create and show floating notification
        var notification = document.createElement('div');
        notification.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 6px; vertical-align: middle;"><polyline points="20,6 9,17 4,12"></polyline></svg>Item added to cart';
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: var(--primary-color);
            color: var(--text-white);
            padding: 12px 20px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 500;
            z-index: 10000;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            transform: translateX(100%);
            transition: transform 0.3s ease;
            display: flex;
            align-items: center;
        `;
        
        document.body.appendChild(notification);
        
        // Animate in
        setTimeout(function() {
            notification.style.transform = 'translateX(0)';
        }, 100);
        
        // Animate out and remove
        setTimeout(function() {
            notification.style.transform = 'translateX(100%)';
            setTimeout(function() {
                if (notification.parentNode) {
                    notification.parentNode.removeChild(notification);
                }
            }, 300);
        }, 2000);
    }
    
    var RITUAL_PWW_KEY = 'pairs_well_with_used';
    var RITUAL_PRODUCTS = {
        trio: {
            handle: 'rosemary-hair-trio',
            title: 'Rosemary Hair Trio',
            variantId: 42361322504281,
            price: 9800,
            was: 11800,
            image: '//cdn.shopify.com/s/files/1/2476/2990/files/rosemary-trio.png?v=1746972280'
        },
        duo: {
            handle: 'rosemary-wash-duo',
            title: 'Rosemary Wash Duo',
            variantId: 41020623192153,
            price: 7400,
            was: 8100,
            image: '//cdn.shopify.com/s/files/1/2476/2990/files/rosemary-wash-duo.png?v=1770967582'
        }
    };
    var RITUAL_MULTI_OIL = ['2-month-supply', '2-months-supply', '3-month-supply', '3-months-supply'];

    function cart_handles_from(cart) {
        return (cart.items || []).map(function(item) { return item.handle; });
    }

    function cart_has_any(handles, list) {
        return handles.some(function(handle) { return list.indexOf(handle) !== -1; });
    }

    function cart_qty_for(cart, handle_list) {
        var n = 0;
        (cart.items || []).forEach(function(item) {
            if (handle_list.indexOf(item.handle) !== -1) {
                n += Number(item.quantity) || 1;
            }
        });
        return n;
    }

    function ritual_pww_used() {
        try { return sessionStorage.getItem(RITUAL_PWW_KEY) === 'true'; } catch (e) { return false; }
    }

    function mark_ritual_pww_used() {
        try { sessionStorage.setItem(RITUAL_PWW_KEY, 'true'); } catch (e) {}
    }

    function ritual_after_total(cart, remove_handles, add_price) {
        var total = 0;
        (cart.items || []).forEach(function(item) {
            if (remove_handles.indexOf(item.handle) === -1) {
                total += item.final_line_price || item.line_price || 0;
            }
        });
        return total + add_price;
    }

    function build_ritual_offer(kind, ctx) {
        var product = RITUAL_PRODUCTS[kind];
        var cart_total = (ctx.cart && ctx.cart.items_subtotal_price) || 0;
        var remove = [];
        var body;
        var cta;
        var bullets;
        var bubble;
        var after;

        if (kind === 'trio') {
            cta = 'Upgrade to the Trio';
            if (ctx.has1moOil && !ctx.hasDuo && !(ctx.hasShampoo && ctx.hasCond)) {
                body = 'Get better results from your Rosemary Hair Oil by upgrading your whole hair care routine to our non-toxic rosemary ritual.';
                bullets = [
                    { type: 'check', text: 'Rosemary Hair Oil' },
                    { type: 'plus-gold', text: 'Rosemary Shampoo' },
                    { type: 'plus-gold', text: 'Rosemary Conditioner' }
                ];
            } else {
                body = 'Get better results from your rosemary wash by upgrading your whole hair care routine to our non-toxic rosemary ritual.';
                bullets = [
                    { type: 'check', text: 'Rosemary Shampoo' },
                    { type: 'check', text: 'Rosemary Conditioner' },
                    { type: 'plus-gold', text: 'Rosemary Hair Oil' }
                ];
            }
            remove = ['rosemary-hair-oil', 'rosemary-wash-duo']
                .concat(rosemary_shampoo_equivalents)
                .concat(rosemary_conditioner_equivalents)
                .concat(RITUAL_MULTI_OIL);
            after = ritual_after_total(ctx.cart, remove, product.price);
            if (ctx.hasDuo) {
                bubble = 'SAVINGS + FREE SHIPPING';
            } else if (cart_total >= FREE_SHIPPING_THRESHOLD_CENTS) {
                bubble = 'SAVE $20';
            } else if (after >= FREE_SHIPPING_THRESHOLD_CENTS) {
                bubble = 'SAVE $20 + FREE SHIPPING';
            } else {
                bubble = 'SAVE $20';
            }
        } else if (ctx.fromShampoo) {
            cta = 'Upgrade to the Wash Duo';
            body = 'Get better results from your Rosemary Shampoo by adding our non-toxic rosemary conditioner to your wash days.';
            bullets = [
                { type: 'check', text: 'Rosemary Shampoo' },
                { type: 'plus-gold', text: 'Rosemary Conditioner' }
            ];
            remove = rosemary_shampoo_equivalents.concat(rosemary_conditioner_equivalents);
            bubble = 'SAVINGS';
        } else {
            cta = 'Add the Wash Duo';
            body = 'Get better results from your Rosemary Hair Oil by adding our non-toxic rosemary wash to your routine.';
            bullets = [
                { type: 'plus-green', text: 'Rosemary Shampoo' },
                { type: 'plus-green', text: 'Rosemary Conditioner' }
            ];
            remove = rosemary_shampoo_equivalents.concat(rosemary_conditioner_equivalents);
            after = ritual_after_total(ctx.cart, remove, product.price);
            if (cart_total < FREE_SHIPPING_THRESHOLD_CENTS && after >= FREE_SHIPPING_THRESHOLD_CENTS) {
                bubble = 'SAVINGS + FREE SHIPPING';
            } else if (cart_total >= FREE_SHIPPING_THRESHOLD_CENTS) {
                bubble = 'BEST VALUE';
            } else {
                bubble = 'SAVINGS';
            }
        }

        return {
            kind: kind,
            title: product.title,
            image: product.image,
            variantId: product.variantId,
            handle: product.handle,
            was: product.was,
            now: product.price,
            cta: cta,
            body: body,
            bullets: bullets,
            bubble: bubble,
            removeHandles: remove
        };
    }

    function ritual_offer_for_cart(cart) {
        var handles = cart_handles_from(cart);
        if (!handles.length) return null;
        if (handles.indexOf('rosemary-hair-trio') !== -1) return null;
        if (ritual_pww_used()) return null;

        var oilSingles = cart_qty_for(cart, ['rosemary-hair-oil']);
        var hasMultiOil = cart_has_any(handles, RITUAL_MULTI_OIL) || oilSingles >= 2;
        var has1moOil = oilSingles === 1 && !hasMultiOil;
        var hasDuo = handles.indexOf('rosemary-wash-duo') !== -1;
        var hasShampoo = cart_has_any(handles, rosemary_shampoo_equivalents);
        var hasCond = cart_has_any(handles, rosemary_conditioner_equivalents);
        var rosemary_cart = oilSingles > 0 || hasMultiOil || hasDuo || hasShampoo || hasCond;
        if (!rosemary_cart) return null;

        if (hasMultiOil) {
            if (hasDuo || (hasShampoo && hasCond)) return null;
            return build_ritual_offer('duo', {
                fromOil: true,
                hasShampoo: hasShampoo,
                hasCond: hasCond,
                cart: cart
            });
        }
        if (has1moOil || hasDuo || (hasShampoo && hasCond)) {
            return build_ritual_offer('trio', {
                has1moOil: has1moOil,
                hasDuo: hasDuo,
                hasShampoo: hasShampoo,
                hasCond: hasCond,
                cart: cart
            });
        }
        if (hasShampoo) {
            return build_ritual_offer('duo', {
                fromShampoo: true,
                cart: cart
            });
        }
        return null;
    }

    function ritual_bullet_html(bullet) {
        var check_svg = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20,6 9,17 4,12"></polyline></svg>';
        var plus_svg = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
        var cls = 'check-icon';
        var svg = check_svg;
        if (bullet.type === 'plus-gold') {
            cls += ' plus-icon';
            svg = plus_svg;
        } else if (bullet.type === 'plus-green') {
            cls += ' plus-icon plus-green';
            svg = plus_svg;
        }
        return '<li><span class="' + cls + '">' + svg + '</span>' + bullet.text + '</li>';
    }

    function track_ritual_popup(name, offer) {
        var props = {
            offer: offer.kind,
            offer_title: offer.title,
            cta: offer.cta,
            handle: offer.handle
        };
        try {
            if (typeof klaviyo !== 'undefined' && typeof klaviyo.track === 'function') {
                klaviyo.track(name, props);
                return;
            }
            if (typeof klaviyo !== 'undefined' && typeof klaviyo.push === 'function') {
                klaviyo.push(['track', name, props]);
            }
        } catch (e) {}
    }

    function apply_ritual_offer(offer) {
        return fetch('/cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cart) {
                var updates = {};
                (cart.items || []).forEach(function(item) {
                    if (offer.removeHandles.indexOf(item.handle) !== -1) {
                        updates[item.key] = 0;
                    }
                });
                if (!Object.keys(updates).length) {
                    return cart;
                }
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: updates })
                }).then(function(response) { return response.json(); });
            })
            .then(function() {
                return add_to_cart_silent(offer.variantId, 1, { '_ritual_upgrade': 'true' });
            });
    }

    function populate_ritual_popup(offer) {
        var popup_card = document.getElementById('upsell-product-card');
        if (!popup_card) return;

        var bullets_html = offer.bullets.map(ritual_bullet_html).join('');
        popup_card.innerHTML =
            '<div class="row copy-row align-items-center">' +
                '<div class="col-lg-4 col-md-5 col-12"><div class="upsell-product-image">' +
                    '<img src="' + offer.image + '" alt="' + offer.title + '" class="img-fluid">' +
                '</div></div>' +
                '<div class="col-lg-8 col-md-7 col-12"><div class="upsell-product-details">' +
                    '<h3 class="mb-2">' + offer.title + '</h3>' +
                    '<p class="mb-3">' + offer.body + '</p>' +
                    '<ul class="benefits-checklist mb-0 d-none d-md-block">' + bullets_html + '</ul>' +
                '</div></div>' +
            '</div>' +
            '<div class="upsell-actions">' +
                '<button class="btn-primary btn-with-save-bubble upsell-add-to-cart">' +
                    (offer.bubble ? '<div class="save-bubble">' + offer.bubble + '</div>' : '') +
                    '<div class="btn-content"><div class="btn-main-text">' + offer.cta + '</div>' +
                    '<div class="btn-pricing">' +
                        '<span class="btn-original-price">' + format_currency(offer.was) + '</span>' +
                        '<span class="btn-sale-price">' + format_currency(offer.now) + '</span>' +
                    '</div></div>' +
                '</button>' +
                '<button class="btn-skip upsell-decline">No thanks, continue to checkout</button>' +
            '</div>';

        popup_card.querySelector('.upsell-add-to-cart').addEventListener('click', function() {
            var button = this;
            button.disabled = true;
            var original_classes = button.className;
            var original_text = button.innerHTML;
            button.className = button.className.replace(/btn-primary/g, 'btn-loading');
            button.innerHTML = '<span class="btn-spinner"></span>Updating Cart';
            track_ritual_popup('Accepted Ritual Popup', offer);
            apply_ritual_offer(offer).then(function() {
                button.innerHTML = '<span class="btn-spinner"></span>Redirecting to Checkout';
                setTimeout(function() {
                    var discount_url = sessionStorage.getItem('discount_redirect_url');
                    window.location.href = discount_url || '/checkout';
                }, 600);
            }).catch(function(error) {
                button.disabled = false;
                button.className = original_classes;
                button.innerHTML = original_text;
                console.error('Error applying ritual upgrade:', error);
            });
        });

        popup_card.querySelector('.upsell-decline').addEventListener('click', function() {
            var button = this;
            button.disabled = true;
            button.innerHTML = '<span class="btn-spinner"></span>Redirecting to Checkout';
            track_ritual_popup('Declined Ritual Popup', offer);
            setTimeout(function() {
                var discount_url = sessionStorage.getItem('discount_redirect_url');
                window.location.href = discount_url || '/checkout';
            }, 400);
        });
    }

    function show_ritual_popup(offer) {
        populate_ritual_popup(offer);
        close_cart();
        open_upsell_popup();
        var checkout_button = document.querySelector('.btn-checkout');
        if (checkout_button) {
            checkout_button.disabled = false;
            checkout_button.className = checkout_button.className.replace(/btn-loading/g, 'btn-primary');
            refresh_cart_ui();
        }
        fetch('/products/' + offer.handle + '.js')
            .then(function(response) { return response.json(); })
            .then(function(product) {
                if (product.featured_image) {
                    offer.image = product.featured_image;
                    var img = document.querySelector('#upsell-product-card .upsell-product-image img');
                    if (img) img.src = product.featured_image;
                }
                if (product.variants && product.variants[0] && product.variants[0].id) {
                    offer.variantId = product.variants[0].id;
                }
            })
            .catch(function() {});
    }

    // Handle upsell buttons (cart upsells and product page upsells)
    function handle_upsell_buttons() {
        document.addEventListener('click', function(e) {
            if (e.target.classList.contains('upsell-add-btn')) {
                var button = e.target;
                var variant_id = button.getAttribute('data-variant-id');
                var is_product_page = button.closest('.product-upsell-section') !== null;
                
                if (variant_id) {
                    // Show loading state
                    button.disabled = true;
                    button.style.opacity = '0.5';
                    button.style.pointerEvents = 'none';
                    var original_text = button.innerHTML;
                    button.innerHTML = '<span class="btn-spinner" style="width: 14px; height: 14px; border-width: 2px; margin: 0 auto; display: inline-block; vertical-align: middle; border-color: var(--text-white); border-top-color: transparent;"></span>';
                    
                    if (is_product_page) {
                        // Product page upsell - add to cart without opening cart
                        add_to_cart_silent(variant_id, 1)
                            .then(function() {
                                // Show success feedback
                                show_add_to_cart_feedback(button);
                            })
                            .finally(function() {
                                // Restore button state after delay
                                setTimeout(function() {
                                    button.disabled = false;
                                    button.style.opacity = '';
                                    button.style.pointerEvents = '';
                                    button.innerHTML = original_text;
                                }, 1500);
                            });
                    } else {
                        // Cart upsell - add to cart and open cart
                        add_to_cart(variant_id, 1)
                            .then(function() {
                                mark_ritual_pww_used();
                                // Show success checkmark (item will be hidden by upsells refresh)
                                button.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20,6 9,17 4,12"></polyline></svg>';
                                button.style.pointerEvents = '';
                            })
                            .catch(function(error) {
                                // Restore button state on error
                                button.disabled = false;
                                button.style.opacity = '';
                                button.style.pointerEvents = '';
                                button.innerHTML = original_text;
                                console.error('Error adding to cart:', error);
                            });
                    }
                }
            }
        });
    }
    
    // Handle checkout button
    function handle_checkout_button() {
        document.addEventListener('click', function(e) {
            if (!(e.target.classList.contains('btn-checkout') || e.target.closest('.btn-checkout'))) {
                return;
            }
            e.preventDefault();

            var checkout_button = e.target.classList.contains('btn-checkout') ? e.target : e.target.closest('.btn-checkout');
            if (checkout_button) {
                checkout_button.disabled = true;
                checkout_button.className = checkout_button.className.replace(/btn-primary/g, 'btn-loading');
                checkout_button.innerHTML = '<span class="btn-spinner"></span>Processing...';
            }

            fetch('/cart.js')
                .then(function(response) { return response.json(); })
                .then(function(cart) {
                    var offer = ritual_offer_for_cart(cart);
                    if (offer) {
                        if (checkout_button) {
                            checkout_button.innerHTML = '<span class="btn-spinner"></span>Loading Offer...';
                        }
                        show_ritual_popup(offer);
                    } else {
                        redirect_to_checkout_from_upsell();
                    }
                })
                .catch(function(error) {
                    console.error('Error checking cart for ritual offer:', error);
                    redirect_to_checkout_from_upsell();
                });
        });
    }
    
    // Old 20% Pairs Well With popup. Kept only so leftover calls go to checkout.
    function show_upsell_popup_from_cart(upsell_item) {
        redirect_to_checkout_from_upsell();
        return;
        if (!upsell_item) {
            redirect_to_checkout_from_upsell();
            return;
        }
        
        var product_handle = upsell_item.getAttribute('data-product-handle');
        var variant_id = upsell_item.querySelector('.upsell-add-btn') ? 
            upsell_item.querySelector('.upsell-add-btn').getAttribute('data-variant-id') : null;
        var product_title = upsell_item.querySelector('.upsell-name') ? 
            upsell_item.querySelector('.upsell-name').textContent.trim() : '';
        var product_description = upsell_item.querySelector('.upsell-description') ? 
            upsell_item.querySelector('.upsell-description').textContent.trim() : '';
        var product_url = upsell_item.querySelector('.upsell-name a') ? 
            upsell_item.querySelector('.upsell-name a').getAttribute('href') : '/products/' + product_handle;
        var product_image = upsell_item.querySelector('.upsell-image img') ? 
            upsell_item.querySelector('.upsell-image img').getAttribute('src') : '';
        
        // Get price from upsell item
        var current_price_element = upsell_item.querySelector('.current-price');
        var original_price_element = upsell_item.querySelector('.original-price');
        var current_price_text = current_price_element ? current_price_element.textContent.trim() : '$39';
        var original_price_text = original_price_element ? original_price_element.textContent.trim() : current_price_text;
        
        // Parse prices to cents
        var current_price_value = parseFloat(current_price_text.replace(/[^0-9.]/g, ''));
        var original_price_value = original_price_element ? 
            parseFloat(original_price_text.replace(/[^0-9.]/g, '')) : current_price_value;
        var current_price_cents = Math.round(current_price_value * 100);
        var original_price_cents = Math.round(original_price_value * 100);
        
        if (!product_handle || !variant_id) {
            console.error('Missing required data from upsell item');
            redirect_to_checkout_from_upsell();
            return;
        }
        
        // Build product object from DOM data
        var product = {
            handle: product_handle,
            title: product_title,
            url: product_url,
            featured_image: product_image,
            variants: [{
                id: variant_id,
                price: current_price_cents
            }]
        };
        
        // Populate popup using existing function (20% discount)
        populate_upsell_popup_with_discount(product, 20);
        // Close the cart before showing the popup: the cart's z-index is higher
        // than the popup's, so leaving it open buries the popup (full-screen on
        // mobile), making checkout appear dead.
        close_cart();
        open_upsell_popup();
        start_countdown_timer();
        
        // Restore checkout button state after upsell popup is shown
        var checkout_button = document.querySelector('.btn-checkout');
        if (checkout_button) {
            checkout_button.disabled = false;
            checkout_button.className = checkout_button.className.replace(/btn-loading/g, 'btn-primary');
            // Restore original button content (this will be updated by update_checkout_button_with_savings)
            refresh_cart_ui();
        }
    }
    
    // Helper function to redirect to checkout from upsell flow
    function redirect_to_checkout_from_upsell() {
        var checkout_button = document.querySelector('.btn-checkout');
        if (checkout_button) {
            checkout_button.disabled = false;
            checkout_button.className = checkout_button.className.replace(/btn-loading/g, 'btn-primary');
            checkout_button.innerHTML = '<span class="btn-spinner"></span>Redirecting to Checkout';
            
            setTimeout(function() {
                var discount_url = sessionStorage.getItem('discount_redirect_url');
                window.location.href = discount_url || '/checkout';
            }, 500);
        } else {
            var discount_url = sessionStorage.getItem('discount_redirect_url');
            window.location.href = discount_url || '/checkout';
        }
    }
    
    // Populate upsell popup with product data and discount
    function populate_upsell_popup_with_discount(product, discount_percentage) {
        var popup_card = document.getElementById('upsell-product-card');
        if (!popup_card) return;
        
        var variant = product.variants[0];
        
        // Apply specified discount percentage for upsell
        var original_price = variant.price;
        discount_percentage = discount_percentage || 20; // Default to 20% if not specified
        var discount_amount = Math.round(original_price * (discount_percentage / 100));
        var discounted_price = original_price - discount_amount;
        var savings = discount_amount;
        
        // Determine if user is in USA for free shipping messaging
        var currency_code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'USD';
        var country_code = (window.Shopify && window.Shopify.country) ? window.Shopify.country : 'US';
        var is_usa_user = (currency_code === 'USD' || country_code === 'US');
        
        // Check if adding this product will qualify for free shipping
        var free_shipping_threshold = FREE_SHIPPING_THRESHOLD_CENTS;
        var will_qualify_for_free_shipping = is_usa_user && discounted_price >= free_shipping_threshold;
        
        var product_descriptions = {
            'rosemary-hair-oil': {
                description: 'Nourishing rosemary oil for less shedding and fuller-looking, healthier hair. Absorbs fast, never greasy.',
                benefits: [
                    'Less shedding over time',
                    'Fuller-looking, healthier hair',
                    'A calmer, less itchy scalp',
                    'Absorbs fast, no greasy residue'
                ]
            },
            'eucalyptus-peppermint-body-wash': {
                description: 'Cooling eucalyptus and peppermint body wash. Lathers richly, rinses clean, never strips your skin.',
                benefits: [
                    'Cooling, invigorating scent',
                    'Skin feels soft, not stripped',
                    'Sulfate-free, plant-based formula',
                    'Real scent from real plants'
                ]
            },
            'lavender-orange-body-wash': {
                description: 'Calming lavender and orange body wash. Lathers richly, rinses clean, never greasy.',
                benefits: [
                    'Calming lavender and orange scent',
                    'Soft skin, never stripped',
                    'Sulfate-free, plant-based formula',
                    'Real scent from real plants'
                ]
            },
            'rosemary-shampoo': {
                description: 'Sulfate-free rosemary shampoo for less shedding and a healthier-looking scalp. Real rosemary extract.',
                benefits: [
                    'Less shedding over time',
                    'A healthier-looking scalp',
                    'Sulfate-free, coconut-derived cleanser',
                    'Real rosemary scent, not synthetic'
                ]
            },
            'rosemary-conditioner': {
                description: 'Rosemary conditioner for softer, fuller-looking hair. Lightweight, no silicone buildup.',
                benefits: [
                    'Softer hair from the first wash',
                    'Less breakage, less tangling',
                    'Lightweight, no buildup',
                    'No silicones or sulfates'
                ]
            },
            'soothing-cream': {
                description: 'Fast-absorbing turmeric and ginger cream for tired muscles and stiff joints. No greasy residue.',
                benefits: [
                    'For sore muscles after workouts',
                    'For stiff or achy joints',
                    'Absorbs in minutes, no residue',
                    'Clean ingredients you can read'
                ]
            },
            'energizing-cream': {
                description: 'Lavender and orange cream that absorbs fast, never sticky. For soft, hydrated skin.',
                benefits: [
                    'Soft, hydrated skin',
                    'Fast-absorbing, never greasy',
                    'Use on face, hands, or neck',
                    'Clean ingredients you can read'
                ]
            },
            'rejuvenating-cream': {
                description: 'Lightweight rosemary and lavender cream. Fast-absorbing, never greasy.',
                benefits: [
                    'Lightweight daily hydration',
                    'Absorbs quickly, no stickiness',
                    'Real rosemary and lavender scent',
                    'Clean ingredients you can read'
                ]
            }
        };
        
        // Get product-specific content or fallback to general description
        var product_handle = product.handle;
        var product_data = product_descriptions[product_handle];
        
        var description = product_data ? product_data.description : '';
        var benefits_details = product_data ? product_data.benefits : [];
        
        // Generate benefits section HTML using checklist format
        var benefits_html = '';
        if (benefits_details && benefits_details.length > 0) {
            benefits_html = `
                <ul class="benefits-checklist mb-4 d-none d-md-block">
                    ${benefits_details.map(function(benefit_text) {
                        return `
                            <li>
                                <span class="check-icon">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="20,6 9,17 4,12"></polyline>
                                    </svg>
                                </span>
                                ${benefit_text}
                            </li>
                        `;
                    }).join('')}
                </ul>
            `;
        }
        
        popup_card.innerHTML = `
            <div class="row">
                <div class="col-lg-4 col-md-5 col-12">
                    <div class="upsell-product-image">
                        <img src="${product.featured_image}" alt="${product.title}" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-8 col-md-7 col-12">
                    <div class="upsell-product-details">
                        <h3 class="mb-2">${product.title}</h3>
                        <p class="mb-3">${description}</p>
                        ${benefits_html}
                        <div class="upsell-actions">
                            <button class="btn-primary btn-with-save-bubble upsell-add-to-cart" data-variant-id="${variant.id}" data-original-price="${original_price}" data-discounted-price="${discounted_price}" data-discount-percentage="${discount_percentage}">
                                <div class="save-bubble">SAVE ${discount_percentage}%${will_qualify_for_free_shipping ? ' + FREE SHIPPING' : ''}</div>
                                <div class="btn-content">
                                    <div class="btn-main-text">Add to order</div>
                                    <div class="btn-pricing">
                                        <span class="btn-original-price">${format_currency(original_price)}</span>
                                        <span class="btn-sale-price">${format_currency(discounted_price)}</span>
                                    </div>
                                </div>
                            </button>
                            <button class="btn-outline upsell-decline">No thanks<span class="d-none d-md-inline">, continue to checkout</span></button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        // Bind upsell popup buttons
        popup_card.querySelector('.upsell-add-to-cart').addEventListener('click', function() {
            var button = this;
            var variant_id = button.getAttribute('data-variant-id');
            var original_price = parseInt(button.getAttribute('data-original-price'));
            var discounted_price = parseInt(button.getAttribute('data-discounted-price'));
            var discount_percentage = parseInt(button.getAttribute('data-discount-percentage'));
            
            // Show loading state
            button.disabled = true;
            var original_classes = button.className;
            var original_text = button.innerHTML;
            button.className = button.className.replace(/btn-primary/g, 'btn-loading');
            button.innerHTML = '<span class="btn-spinner"></span>Adding to Cart';
            
            // Add product with discount properties
            var properties = {
                '_upsell_discount': discount_percentage + '%',
                '_original_price': format_currency(original_price),
                '_discounted_price': format_currency(discounted_price),
                '_savings': format_currency(original_price - discounted_price)
            };
            
            // Add product with discount - pass original price for discount code selection
            add_to_cart_with_discount(variant_id, 1, original_price, properties).then(function() {
                // Show redirecting state
                button.innerHTML = '<span class="btn-spinner"></span>Redirecting to Checkout';
                
                // Redirect after short delay
                setTimeout(function() {
                    // Use discount URL if available
                    var discount_url = sessionStorage.getItem('discount_redirect_url');
                    window.location.href = discount_url || '/checkout';
                }, 1000);
            }).catch(function(error) {
                // Restore button state on error
                button.disabled = false;
                button.className = original_classes;
                button.innerHTML = original_text;
                console.error('Error adding to cart:', error);
            });
        });
        
        popup_card.querySelector('.upsell-decline').addEventListener('click', function() {
            var button = this;

            button.disabled = true;
            var original_classes = button.className;
            var original_text = button.innerHTML;
            button.className = button.className.replace(/btn-outline/g, 'btn-loading');
            button.innerHTML = '<span class="btn-spinner"></span>Redirecting to Checkout';
            
            setTimeout(function() {
                var discount_url = sessionStorage.getItem('discount_redirect_url');
                window.location.href = discount_url || '/checkout';
            }, 1000);
        });
    }
    
    // Start countdown timer for upsell popup
    function start_countdown_timer() {
        var timer_element = document.getElementById('countdown-timer');
        if (!timer_element) return;
        
        var minutes = 9;
        var seconds = 59;
        
        var countdown_interval = setInterval(function() {
            var minutes_element = timer_element.querySelector('.countdown-minutes');
            var seconds_element = timer_element.querySelector('.countdown-seconds');
            
            if (minutes_element) {
                minutes_element.textContent = minutes.toString().padStart(2, '0');
            }
            if (seconds_element) {
                seconds_element.textContent = seconds.toString().padStart(2, '0');
            }
            
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(countdown_interval);
                    close_upsell_popup();
                    window.location.href = '/checkout';
                    return;
                }
                minutes--;
                seconds = 59;
            } else {
                seconds--;
            }
        }, 1000);
    }
    
    // Bind cart icon click to open cart
    if (cart_icon) {
        cart_icon.addEventListener('click', function(e) {
            e.preventDefault();
            open_cart();
        });
    }
    
    // Bind close events for cart
    if (cart_close_btn) {
        cart_close_btn.addEventListener('click', close_cart);
    }
    
    if (cart_overlay) {
        cart_overlay.addEventListener('click', close_cart);
    }
    
    // Bind close events for upsell popup (disabled - prevent closing)
    if (upsell_popup) {
        upsell_popup.addEventListener('click', function(e) {
            // Prevent closing by clicking outside - do nothing
            e.preventDefault();
        });
    }
    
    // Close cart/popup on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            if (sliding_cart && sliding_cart.classList.contains('active')) {
                close_cart();
            }
            // Disabled: Prevent closing upsell popup with Escape key
            // if (upsell_popup && upsell_popup.classList.contains('active')) {
            //     close_upsell_popup();
            // }
        }
    });
    
    // Handle URL parameters for cart opening and search opening
    function handle_url_parameters() {
        var url_params = new URLSearchParams(window.location.search);
        
        // Handle cart parameter
        if (url_params.get('cart') === 'open') {
            open_cart();
            // Clean up URL without refreshing page
            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, window.location.pathname);
            }
        }
        
        // Handle search parameter
        if (url_params.get('search') === 'open') {
            // Wait for DOM to be ready and search functionality to be initialized
            setTimeout(function() {
                var search_tab_container = document.getElementById('search-tab-container');
                if (search_tab_container) {
                    // Expand search tab
                    search_tab_container.click();
                    
                    // Focus on search input after expansion
                    setTimeout(function() {
                        var search_input = document.getElementById('product-search');
                        if (search_input) {
                            search_input.focus();
                            // Force keyboard to show on mobile
                            if (search_input.setSelectionRange) {
                                search_input.setSelectionRange(0, 0);
                            }
                        }
                        
                        // Scroll to search section
                        var filter_section = document.querySelector('.collection-filter-section');
                        if (filter_section) {
                            filter_section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }, 300);
                }
            }, 100);
            
            // Clean up URL without refreshing page
            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, window.location.pathname);
            }
        }
    }
    
    // Override existing add to cart forms
    function override_add_to_cart_forms() {
        document.addEventListener('submit', function(e) {
            var form = e.target;
            if (form.action && form.action.includes('/cart/add')) {
                // Handle forms with direct checkout (e.g., gift cards) - show loading then submit
                if (form.hasAttribute('data-direct-checkout')) {
                    e.preventDefault();
                    // Check form validity first
                    if (!form.checkValidity()) {
                        form.reportValidity();
                        return;
                    }
                    // Show loading state on submit button (same style as cart checkout)
                    var submit_btn = form.querySelector('button[type="submit"]');
                    if (submit_btn) {
                        submit_btn.disabled = true;
                        submit_btn.className = submit_btn.className.replace(/btn-primary/g, 'btn-loading');
                        submit_btn.innerHTML = '<span class="btn-spinner"></span>Redirecting to Checkout...';
                    }
                    // Submit the form programmatically
                    form.submit();
                    return;
                }
                
                // Check form validity before preventing default (for required fields)
                if (!form.checkValidity()) {
                    form.reportValidity();
                    return;
                }
                
                e.preventDefault();
                
                var form_data = new FormData(form);
                var variant_id = form_data.get('id');
                var quantity = form_data.get('quantity') || 1;
                var properties = {};
                
                // Collect any properties
                for (var pair of form_data.entries()) {
                    if (pair[0].startsWith('properties[')) {
                        var property_name = pair[0].replace('properties[', '').replace(']', '');
                        properties[property_name] = pair[1];
                    }
                }
                
                if (variant_id) {
                    add_to_cart(variant_id, parseInt(quantity), Object.keys(properties).length > 0 ? properties : null);
                }
            }
        });
        
        // Also handle button clicks that might trigger form submission
        document.addEventListener('click', function(e) {
            var button = e.target;
            var closest_button = e.target.closest('button');
            
            // Check if it's an add to cart button (either the button itself or a child element)
            if (closest_button && (
                closest_button.classList.contains('add-to-cart-btn') ||
                closest_button.textContent.includes('ADD TO CART') ||
                closest_button.classList.contains('add-to-cart')
            )) {
                var form = closest_button.closest('form');
                if (form && form.action && form.action.includes('/cart/add')) {
                    // Handle forms with direct checkout (e.g., gift cards) - show loading then submit
                    if (form.hasAttribute('data-direct-checkout')) {
                        e.preventDefault();
                        e.stopPropagation();
                        // Check form validity first
                        if (!form.checkValidity()) {
                            form.reportValidity();
                            return;
                        }
                        // Show loading state on button (same style as cart checkout)
                        closest_button.disabled = true;
                        closest_button.className = closest_button.className.replace(/btn-primary/g, 'btn-loading');
                        closest_button.innerHTML = '<span class="btn-spinner"></span>Redirecting to Checkout...';
                        // Submit the form programmatically
                        form.submit();
                        return;
                    }
                    
                    // Check form validity before preventing default (for required fields)
                    if (!form.checkValidity()) {
                        form.reportValidity();
                        return;
                    }
                    
                    e.preventDefault();
                    e.stopPropagation(); // Prevent parent link navigation
                    
                    var form_data = new FormData(form);
                    var variant_id = form_data.get('id') || closest_button.getAttribute('data-variant-id');
                    var quantity = form_data.get('quantity') || 1;
                    var properties = {};
                    
                    // Collect any properties
                    for (var pair of form_data.entries()) {
                        if (pair[0].startsWith('properties[')) {
                            var property_name = pair[0].replace('properties[', '').replace(']', '');
                            properties[property_name] = pair[1];
                        }
                    }
                    
                    if (variant_id) {
                        // Add loading state to button
                        closest_button.disabled = true;
                        var original_classes = closest_button.className;
                        var original_text = closest_button.innerHTML;
                        
                        // Apply loading state
                        closest_button.className = closest_button.className.replace(/btn-primary/g, 'btn-loading');
                        closest_button.innerHTML = '<span class="btn-spinner"></span>Adding to Cart';
                        
                        add_to_cart(variant_id, parseInt(quantity), Object.keys(properties).length > 0 ? properties : null)
                            .finally(function() {
                                // Restore button state
                                closest_button.disabled = false;
                                closest_button.className = original_classes;
                                closest_button.innerHTML = original_text;
                            });
                    }
                }
            }
        });
    }
    
    // Reset cart UI to prevent stuck loading states
    function reset_cart_ui() {
        // Close any open upsell popup
        if (upsell_popup && upsell_popup.classList.contains('active')) {
            upsell_popup.classList.remove('active');
        }
        
        // Clear any pending discount redirect URLs from session storage
        try {
            sessionStorage.removeItem('discount_redirect_url');
            sessionStorage.removeItem('pending_discount_code');
        } catch (e) {
            // Ignore storage errors
        }
        
        // Reload the entire cart UI - this will reset all button states naturally
        refresh_cart_ui();
    }
    
    // Reset cart UI on page load/return
    reset_cart_ui();
    
    // Also reset on page visibility change (handles back button navigation)
    document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
            // Page became visible again (user returned via back button)
            setTimeout(reset_cart_ui, 100);
        }
    });
    
    // Reset on page focus (additional safety for back button)
    window.addEventListener('focus', function() {
        setTimeout(reset_cart_ui, 100);
    });

    // Initialize cart functionality
    handle_quantity_buttons();
    handle_upsell_buttons();
    handle_checkout_button();
    handle_url_parameters();
    override_add_to_cart_forms();
    
    // Fetch initial cart data
    fetch_cart();
});

// Floating scroll up arrow
document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize floating scroll up arrow
    initialize_floating_scroll_up();

    // Floating Scroll Up Arrow functionality
    function initialize_floating_scroll_up() {
        const floating_btn = document.getElementById('floating-scroll-up-btn');
        const product_section = document.getElementById('product-section');
        
        if (!floating_btn || !product_section) return;
        
        // Helper function to get navigation height
        function get_nav_total_height() {
            const main_nav = document.querySelector('.main-nav');
            const secondary_nav = document.querySelector('.secondary-nav');
            const mobile_secondary_nav = document.querySelector('.mobile-secondary-nav');
            const is_visible = (el) => el && window.getComputedStyle(el).display !== 'none' && el.offsetParent !== null;
            const main_h = is_visible(main_nav) ? main_nav.offsetHeight : 0;
            const secondary_h = is_visible(secondary_nav) ? secondary_nav.offsetHeight : 0;
            const mobile_secondary_h = is_visible(mobile_secondary_nav) ? mobile_secondary_nav.offsetHeight : 0;
            return main_h + (mobile_secondary_h || secondary_h);
        }
        
        // Show/hide button based on scroll position
        function toggle_floating_button() {
            const scroll_top = window.pageYOffset || document.documentElement.scrollTop;
            
            // Show button when user has scrolled past the product section
            const product_section_top = product_section.offsetTop;
            const product_section_bottom = product_section_top + product_section.offsetHeight;
            const should_show = scroll_top > product_section_bottom;
            
            if (should_show) {
                floating_btn.classList.add('show');
            } else {
                floating_btn.classList.remove('show');
            }
        }
        
        // Scroll to product section when button is clicked
        function scroll_to_product_section() {
            const product_section_top = product_section.offsetTop;
            const nav_height = get_nav_total_height();
            const target_position = product_section_top - nav_height - 20;
            
            // Remove hover state immediately when clicked
            floating_btn.style.pointerEvents = 'none';
            
            window.scrollTo({
                top: target_position,
                behavior: 'smooth'
            });
            
            // Re-enable pointer events after scroll completes
            setTimeout(() => {
                floating_btn.style.pointerEvents = 'auto';
            }, 1000);
        }
        
        // Add event listeners
        floating_btn.addEventListener('click', scroll_to_product_section);
        window.addEventListener('scroll', toggle_floating_button);
        
        // Initial check
        toggle_floating_button();
    }
});

// Klaviyo chat: collapse the proactive teaser while the buy box is on screen.
document.addEventListener('DOMContentLoaded', function() {
    var buy_box = document.getElementById('product-add');
    if (!buy_box || !document.body.classList.contains('template-product')) {
        return;
    }

    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            document.body.classList.toggle('buy-box-in-view', entry.isIntersecting);
        });
    }, { threshold: 0.2, rootMargin: '-8px 0px -8px 0px' });

    observer.observe(buy_box);
});

/* ==========================================================================
   UGC Video Grid — hover-to-play + lightbox
   ========================================================================== */
(function () {
    var grid = document.getElementById('ugc-grid');
    if (!grid) return;

    var items = grid.querySelectorAll('.ugc-grid__item');
    var lightbox = document.getElementById('ugc-lightbox');
    var video = document.getElementById('ugc-video');
    var btnClose = document.getElementById('ugc-close');
    var btnPrev = document.getElementById('ugc-prev');
    var btnNext = document.getElementById('ugc-next');
    var btnPlay = document.getElementById('ugc-playpause');
    var btnMute = document.getElementById('ugc-mute');
    var currentIndex = 0;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    // --- Hover-to-autoplay (desktop only) ---
    if (canHover) {
        items.forEach(function (item) {
            var preview = item.querySelector('.ugc-grid__preview');
            if (!preview) return;

            item.addEventListener('mouseenter', function () {
                preview.play().catch(function () {});
            });
            item.addEventListener('mouseleave', function () {
                preview.pause();
                preview.currentTime = 0;
            });
        });
    }

    // --- Lightbox ---
    function openLightbox(index) {
        currentIndex = index;
        loadVideo(index);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
        lightbox.hidden = true;
        document.body.style.overflow = '';
        video.pause();
        video.removeAttribute('src');
        video.load();
        updatePlayIcon(true);
        updateMuteIcon(true);
    }

    function loadVideo(index) {
        var item = items[index];
        if (!item) return;
        var src = item.getAttribute('data-video');
        video.src = src;
        video.muted = true;
        video.play().catch(function () {});
        updatePlayIcon(false);
        updateMuteIcon(true);
    }

    function navigate(dir) {
        currentIndex = (currentIndex + dir + items.length) % items.length;
        loadVideo(currentIndex);
    }

    function updatePlayIcon(paused) {
        var iconPlay = btnPlay.querySelector('.ugc-icon-play');
        var iconPause = btnPlay.querySelector('.ugc-icon-pause');
        iconPlay.style.display = paused ? '' : 'none';
        iconPause.style.display = paused ? 'none' : '';
        btnPlay.setAttribute('aria-label', paused ? 'Play' : 'Pause');
    }

    function updateMuteIcon(muted) {
        var iconMuted = btnMute.querySelector('.ugc-icon-muted');
        var iconUnmuted = btnMute.querySelector('.ugc-icon-unmuted');
        iconMuted.style.display = muted ? '' : 'none';
        iconUnmuted.style.display = muted ? 'none' : '';
        btnMute.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
    }

    // Grid click -> open lightbox
    items.forEach(function (item, i) {
        item.addEventListener('click', function () {
            openLightbox(i);
        });
    });

    btnClose.addEventListener('click', closeLightbox);
    btnPrev.addEventListener('click', function () { navigate(-1); });
    btnNext.addEventListener('click', function () { navigate(1); });

    btnPlay.addEventListener('click', function () {
        if (video.paused) {
            video.play().catch(function () {});
            updatePlayIcon(false);
        } else {
            video.pause();
            updatePlayIcon(true);
        }
    });

    btnMute.addEventListener('click', function () {
        video.muted = !video.muted;
        updateMuteIcon(video.muted);
    });

    // Close on backdrop click
    lightbox.querySelector('.ugc-lightbox__backdrop').addEventListener('click', closeLightbox);

    // Keyboard: Escape to close, arrows to navigate
    document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') navigate(-1);
        if (e.key === 'ArrowRight') navigate(1);
    });

    // Sync play/pause icon with video state
    video.addEventListener('play', function () { updatePlayIcon(false); });
    video.addEventListener('pause', function () { updatePlayIcon(true); });
    video.addEventListener('ended', function () { updatePlayIcon(true); });
})();